"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/react-wrapper.js":
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  console.log("---------react-------");
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var props = {};
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (propsEl) {
        var _appTarget$querySelec;
        props = {};
        props = json_6__WEBPACK_IMPORTED_MODULE_2___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
      }
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_1__.createRoot)(appTarget);
      root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, {
        shopifyData: props
      }));
      return root;
    }
  });
});

/***/ }),

/***/ "./js/components/react/ResponsiveImage.js":
/*!************************************************!*\
  !*** ./js/components/react/ResponsiveImage.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    aspectratio,
    aspect_ratio_mobile,
    image,
    settings
  } = _ref;
  var min = 100;
  var max = 10000;
  var diff = max - min;
  var generated_image_id = Date.now() / diff + min;
  var displayImage = image;
  if (!displayImage) {
    displayImage = {
      width: 1920,
      height: 1080,
      id: Date.now(),
      src: 'https://cdn.shopify.com/s/files/1/0422/2255/1191/files/placeholderImage.webp?v=1692958737'
    };
  }
  var {
    imageFit
  } = settings || {};
  var {
    height: maxHeightImage,
    id: image_id,
    src: imageSrc,
    width: maxWidthImage
  } = displayImage;
  var IMAGE_WIDTHS = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024];
  var getImageWidths = nativeWidth => {
    var imageWidths = [];
    for (var i = 0; i < IMAGE_WIDTHS.length; i++) {
      var width = IMAGE_WIDTHS[i];
      if (nativeWidth > width) {
        imageWidths.push(width);
      } else {
        imageWidths.push(nativeWidth);
        break;
      }
    }
    return imageWidths.join(',');
  };
  var imageSizes = getImageWidths(displayImage.width).split(',');
  var imageSrcSet = imageSizes.map(width => {
    return "".concat(displayImage.src, "&width=").concat(width, " ").concat(width, "w");
  }).join(",");

  // Determine the aspect ratio based on screen size
  var [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(window.innerWidth <= 525);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    var handleResize = () => {
      setIsMobile(window.innerWidth <= 525);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  var currentAspectRatio = isMobile ? aspect_ratio_mobile : aspectratio;
  if (currentAspectRatio <= 1) {
    maxWidthImage = parseInt(maxHeightImage) * currentAspectRatio;
  } else {
    maxHeightImage = parseInt(maxWidthImage) / currentAspectRatio;
  }
  var maxWidthImageFloat = maxWidthImage * 1.0;
  var getWrapperStyles = () => {
    return {
      '--padding-top': "".concat(maxHeightImage / maxWidthImageFloat * 100, "%"),
      '--max-height': "".concat(maxHeightImage, "px"),
      '--max-width': "".concat(maxWidthImage, "px")
    };
  };
  var getImageStyle = () => {
    return {
      objectFit: "".concat(imageFit ? imageFit : 'contain'),
      aspectRatio: "".concat(currentAspectRatio)
    };
  };
  var css = "\n  .responsive-image__wrapper:before {\n    content: '';\n    width: 100%;\n    display: block;\n    padding-top: var(--padding-top);\n  }\n  .responsive-image__wrapper {\n      height: 100%;\n      position: relative;\n      max-width: var(--max-width);\n      max-height: var(--max-height);\n  }\n  .responsive-image__image {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      left: 0;\n      width: 100%;\n      object-fit: var(--objectFit);\n      aspect-ratio: var(--aspectRatio);\n      \n  }";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    id: "ImageWrapper-".concat(image_id, "-").concat(generated_image_id),
    "data-image-id": image_id,
    className: "responsive-image__wrapper",
    style: getWrapperStyles()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    id: "Image-".concat(image_id, "-").concat(generated_image_id),
    className: "responsive-image__image",
    src: displayImage.src,
    alt: displayImage.alt,
    srcSet: imageSrcSet,
    "data-widths": "[".concat(imageSizes, "]"),
    "data-aspectratio": currentAspectRatio,
    "data-sizes": "auto",
    tabIndex: "-1",
    style: getImageStyle()
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("style", null, css)));
});

/***/ }),

/***/ "./js/components/react/factuals.js":
/*!*****************************************!*\
  !*** ./js/components/react/factuals.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ResponsiveImage */ "./js/components/react/ResponsiveImage.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var FactualSection = _ref => {
  var _shopifyData$data;
  var {
    shopifyData
  } = _ref;
  console.log("Shopify Data:", shopifyData);
  var blocks = ((_shopifyData$data = shopifyData.data) === null || _shopifyData$data === void 0 ? void 0 : _shopifyData$data.blocks) || [];
  var blockCount = blocks.length;
  var imageArray = blocks.flatMap(block => {
    var _block$cards;
    return (_block$cards = block.cards) === null || _block$cards === void 0 ? void 0 : _block$cards.map(card => {
      var _block$image;
      return _objectSpread(_objectSpread({}, card), {}, {
        blockImage: (_block$image = block.image) === null || _block$image === void 0 ? void 0 : _block$image[0]
      });
    });
  });
  var [selectedBlock, setselectedBlock] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isFirstImageOpen, setIsFirstImageOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isSecondImageOpen, setIsSecondImageOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var {
    shouldCalculateHeight = false
  } = (shopifyData === null || shopifyData === void 0 ? void 0 : shopifyData.data) || {};
  var [isLargeScreen, setIsLargeScreen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(window.innerWidth > 1200);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1200);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  var srcTokens = {
    replacementToken: "?width=90&height=90",
    dataSrcToken: "?width=width&height=height",
    srcToken: "?width=90&height=90"
  };
  var handleCardClick = card => {
    setselectedBlock(card);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (selectedBlock) {
      setIsFirstImageOpen(true);
    } else {
      setIsFirstImageOpen(false);
    }
  }, [selectedBlock]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var isMobileBreakpoint = matchMedia("(min-width: 768px)").matches ? false : true;
    setIsMobile(isMobileBreakpoint);
  }, []);
  var handleCloseImage = () => {
    setselectedBlock(false);
  };
  var handleNextImage = () => {
    setIsSecondImageOpen(true);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    console.log("data---", selectedBlock);
  }, [selectedBlock]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "container factual_container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "factual__section",
    style: {
      background: "".concat(shopifyData.data.background_color),
      display: "grid",
      gridTemplateColumns: "repeat(".concat(Math.min(blockCount, 2), ", 1fr)")
    }
  }, blocks.map((block, index) => {
    var _block$image2, _selectedBlock$imageS, _selectedBlock$imageS2, _selectedBlock$imageM, _selectedBlock$imageM2, _selectedBlock$imageM3, _selectedBlock$imageS3;
    var image = (_block$image2 = block.image) === null || _block$image2 === void 0 ? void 0 : _block$image2[0];
    var src = image === null || image === void 0 ? void 0 : image.src;
    var width = (image === null || image === void 0 ? void 0 : image.width) || 1920;
    var height = (image === null || image === void 0 ? void 0 : image.height) || 1080;
    var isFirstBlock = index === 0;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      key: index,
      className: "factual__item ".concat(isFirstBlock ? "factual__item--flex" : "", " ").concat(shopifyData.data.swipeMedia === "true" ? "factual__swap-block-mobile" : ""),
      style: {
        position: "relative"
      }
    }, isFirstBlock ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, block.url && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "text-image__button"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      className: "button button__custom-button text__cta",
      href: block.url
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "btn-text button__btn-text"
    }, " ", block.button, " "))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__left",
      style: shouldCalculateHeight && (isFirstImageOpen || isSecondImageOpen) ? {
        minHeight: "660px"
      } : {
        minHeight: "auto"
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__popup-image-desktop"
    }, selectedBlock && (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageSrc[0]) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__top-image",
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 5
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.59,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS = selectedBlock.imageSrc[0]) === null || _selectedBlock$imageS === void 0 ? void 0 : _selectedBlock$imageS.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), selectedBlock && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '10px',
        right: '0',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleCloseImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "71",
      height: "70",
      viewBox: "0 0 71 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "35.5",
      cy: "35",
      r: "17.5",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "27.8399",
      y1: "26.6601",
      x2: "41.9821",
      y2: "40.8022",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "41.9805",
      y1: "27.3321",
      x2: "27.8384",
      y2: "41.4742",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))), (selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS2 = selectedBlock.imageSrc[1]) === null || _selectedBlock$imageS2 === void 0 ? void 0 : _selectedBlock$imageS2.src) && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__next-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '19px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleNextImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "18",
      r: "17",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M13.7908 27.9548L24.3868 18.1175L13.7908 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__popup-image-mobile",
      style: {
        position: 'relative'
      }
    }, selectedBlock && (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageMobile[0]) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__top-image",
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 5
      }
    }, isMobile && isSecondImageOpen ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.582,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM = selectedBlock.imageMobile[1]) === null || _selectedBlock$imageM === void 0 ? void 0 : _selectedBlock$imageM.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '17px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: () => setIsSecondImageOpen(false)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "17.5",
      r: "17",
      transform: "matrix(-1 0 0 1 35 0.5)",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M21.2092 27.9548L10.6132 18.1175L21.2092 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    })))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.582,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM2 = selectedBlock.imageMobile[0]) === null || _selectedBlock$imageM2 === void 0 ? void 0 : _selectedBlock$imageM2.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), selectedBlock && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '-10px',
        right: '-10px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleCloseImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "71",
      height: "70",
      viewBox: "0 0 71 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "35.5",
      cy: "35",
      r: "17.5",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "27.8399",
      y1: "26.6601",
      x2: "41.9821",
      y2: "40.8022",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "41.9805",
      y1: "27.3321",
      x2: "27.8384",
      y2: "41.4742",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))), (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageMobile) && (selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM3 = selectedBlock.imageMobile[1]) === null || _selectedBlock$imageM3 === void 0 ? void 0 : _selectedBlock$imageM3.src) && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__next-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '19px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleNextImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "18",
      r: "17",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M13.7908 27.9548L24.3868 18.1175L13.7908 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__sub-container ".concat(isFirstImageOpen ? "factual__first-image-container" : "")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h1", {
      className: "factual__title"
    }, block.title, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("sup", null, block.title_sup)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
      className: "factual__description",
      dangerouslySetInnerHTML: {
        __html: block.description
      }
    }), block.cards && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__cards"
    }, block.cards.map((card, cardIndex) => {
      var text = card.text;
      if (text) {
        var myStyle = {
          background: "\n                                    linear-gradient(to right bottom, transparent 41%, #fff 0) no-repeat 0 0 / 1.5em 1.5em, \n                                    linear-gradient(135deg, transparent 0.41em, ".concat(card.color, " 0)")
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          key: cardIndex,
          style: myStyle,
          className: "factual__card-item",
          onClick: () => handleCardClick(card)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-cut-icon"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
          width: "32",
          height: "33",
          viewBox: "0 0 32 33",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
          d: "M31 32H3L17 17.5L31 3V32Z",
          fill: "white",
          stroke: "#282FEE",
          strokeWidth: "1.5"
        }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-icon"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
          width: "25",
          height: "25",
          viewBox: "0 0 25 25",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
          cx: "12.5",
          cy: "12.5",
          r: "12",
          fill: "#FEFDF6",
          stroke: "#FEFDF6"
        }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
          d: "M12.9507 9.18C12.6241 9.18 12.3954 9.11467 12.2647 8.984C12.1341 8.844 12.0687 8.67133 12.0687 8.466V8.242C12.0687 8.03667 12.1341 7.86867 12.2647 7.738C12.3954 7.598 12.6241 7.528 12.9507 7.528C13.2774 7.528 13.5061 7.598 13.6367 7.738C13.7674 7.86867 13.8327 8.03667 13.8327 8.242V8.466C13.8327 8.67133 13.7674 8.844 13.6367 8.984C13.5061 9.11467 13.2774 9.18 12.9507 9.18ZM9.78673 17.048H12.3907V11.728H9.78673V10.776H13.5107V17.048H15.9467V18H9.78673V17.048Z",
          fill: "#282FEE"
        }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-content"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-title",
          dangerouslySetInnerHTML: {
            __html: card.card_title
          }
        }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h1", {
          className: "factual__code"
        }, card.text, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("sup", null, card.sup))));
      }
      return null;
    })), block.pyramid && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "pyramid__cards"
    }, block.pyramid.map((card, cardIndex) => {
      var text = card.text;
      console.log("card.pyramid_image.src", card.pyramid_image[0].src);
      if (text) {
        var _card$pyramid_image$;
        var myStyle = {
          backgroundImage: "url(".concat(card === null || card === void 0 || (_card$pyramid_image$ = card.pyramid_image[0]) === null || _card$pyramid_image$ === void 0 ? void 0 : _card$pyramid_image$.src, ")"),
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative'
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          key: "pyramid-".concat(cardIndex),
          className: "factual__pyramid-card-container"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          style: myStyle,
          className: "factual__pyramid-item",
          onClick: () => handleCardClick(card)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-content factual__pyramid-content"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h1", {
          className: "factual__code factual__pyramid-code"
        }, card.text))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__pyramid-title-desc",
          style: _objectSpread({}, !isLargeScreen ? {
            color: card.color
          } : '')
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-title factual__pyramid-title",
          dangerouslySetInnerHTML: {
            __html: "".concat(card.card_title, "<sup>").concat(card.sup, "</sup>")
          }
        }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__pyramid-title"
        }, card.card_desc)));
      }
      return null;
    }))))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__right factual__right-".concat(blockCount)
    }, block.url && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "text-image__button"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      className: "button button__custom-button text__cta",
      href: block.url
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "btn-text button__btn-text"
    }, " ", block.button, " "))), isSecondImageOpen ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__right-image",
      style: {
        position: 'relative'
      }
    }, !isMobile ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.59,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS3 = selectedBlock.imageSrc[1]) === null || _selectedBlock$imageS3 === void 0 ? void 0 : _selectedBlock$imageS3.src,
        width,
        height
      },
      srcTokens: srcTokens
    }) : src && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: " ".concat(block.hideImage === true ? "factual__hide-image" : "", " ")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.9,
      image: {
        src,
        width,
        height
      },
      srcTokens: srcTokens
    })), !isMobile && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '17px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: () => setIsSecondImageOpen(false)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "17.5",
      r: "17",
      transform: "matrix(-1 0 0 1 35 0.5)",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M21.2092 27.9548L10.6132 18.1175L21.2092 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    })))) : src && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: " ".concat(block.hideImage === true ? "factual__hide-image" : "", " ")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.9,
      image: {
        src,
        width,
        height
      },
      srcTokens: srcTokens
    }))));
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FactualSection);

/***/ }),

/***/ "./js/components/react/form-components/Checkbox.js":
/*!*********************************************************!*\
  !*** ./js/components/react/form-components/Checkbox.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["id", "name", "label", "checked", "onChange", "error", "className"];

var Checkbox = _ref => {
  var {
      id,
      name,
      label,
      checked,
      onChange,
      error,
      className = ''
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__field pro-form__field--checkbox ".concat(className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__checkbox-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: id,
    className: "pro-form__field-checkbox-label ".concat(error ? 'pro-form__field-checkbox-label--error' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    type: "checkbox",
    id: id,
    name: name,
    checked: checked,
    onChange: onChange,
    className: "pro-form__field-checkbox-input ".concat(error ? 'pro-form__field-checkbox-input--error' : '')
  }, props)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-checkbox-text"
  }, label))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-error"
  }, error));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Checkbox);

/***/ }),

/***/ "./js/components/react/form-components/DateGroup.js":
/*!**********************************************************!*\
  !*** ./js/components/react/form-components/DateGroup.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["label", "value", "onChange", "required", "error", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var DateGroup = _ref => {
  var {
      label,
      value = {
        month: '',
        day: '',
        year: ''
      },
      onChange,
      required = false,
      error,
      className = ''
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  var handleChange = (field, newValue) => {
    onChange(_objectSpread(_objectSpread({}, value), {}, {
      [field]: newValue
    }));
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__field pro-form__field--date-group ".concat(className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    className: "pro-form__field-label"
  }, label, required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-required"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__date-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
    type: "text",
    id: "month",
    name: "month",
    value: value.month,
    onChange: e => handleChange('month', e.target.value),
    placeholder: "MM",
    maxLength: "2",
    className: "pro-form__field-input pro-form__date-field"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
    type: "text",
    id: "day",
    name: "day",
    value: value.day,
    onChange: e => handleChange('day', e.target.value),
    placeholder: "DD",
    maxLength: "2",
    className: "pro-form__field-input pro-form__date-field"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", {
    type: "text",
    id: "year",
    name: "year",
    value: value.year,
    onChange: e => handleChange('year', e.target.value),
    placeholder: "YYYY",
    maxLength: "4",
    className: "pro-form__field-input pro-form__date-field"
  })), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-error"
  }, error));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (DateGroup);

/***/ }),

/***/ "./js/components/react/form-components/FieldGroup.js":
/*!***********************************************************!*\
  !*** ./js/components/react/form-components/FieldGroup.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["children", "className", "columns"];

var FieldGroup = _ref => {
  var {
      children,
      className = '',
      columns = 2
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    className: "pro-form__field-group pro-form__field-group--".concat(columns, "-columns ").concat(className)
  }, props), children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FieldGroup);

/***/ }),

/***/ "./js/components/react/form-components/FileUpload.js":
/*!***********************************************************!*\
  !*** ./js/components/react/form-components/FileUpload.js ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["id", "name", "label", "onChange", "onRemove", "value", "accept", "error", "className"];

var FileUpload = _ref => {
  var {
      id,
      name,
      label,
      onChange,
      onRemove,
      value,
      // The selected file
      accept = '.pdf,.jpg,.jpeg,.png',
      error,
      className = ''
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  var fileInputRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var handleButtonClick = () => {
    var _fileInputRef$current;
    (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 || _fileInputRef$current.click();
  };
  var handleFileChange = e => {
    var file = e.target.files[0];
    if (file) {
      onChange(file);
    }
  };
  var handleRemove = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    onRemove();
  };
  var getFileIcon = fileName => {
    var extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return '📄';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return '🖼️';
      default:
        return '📎';
    }
  };
  var formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    var k = 1024;
    var sizes = ['Bytes', 'KB', 'MB', 'GB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__field pro-form__field--file-upload ".concat(className)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    className: "pro-form__field-label"
  }, label), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__file-upload-area"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    type: "file",
    id: id,
    name: name,
    ref: fileInputRef,
    onChange: handleFileChange,
    accept: accept,
    className: "pro-form__field-file-input",
    style: {
      display: 'none'
    }
  }, props)), !value ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    type: "button",
    onClick: handleButtonClick,
    className: "pro-form__file-upload-button"
  }, "Add file") : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__file-preview"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__file-preview-info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__file-icon"
  }, getFileIcon(value.name)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__file-details"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__file-name"
  }, value.name), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__file-size"
  }, formatFileSize(value.size)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    type: "button",
    onClick: handleRemove,
    className: "pro-form__file-remove-button",
    title: "Remove file"
  }, "\u2715"))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-error"
  }, error));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FileUpload);

/***/ }),

/***/ "./js/components/react/form-components/Select.js":
/*!*******************************************************!*\
  !*** ./js/components/react/form-components/Select.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["id", "name", "label", "value", "onChange", "options", "required", "error", "className", "placeholder"];

var Select = _ref => {
  var {
      id,
      name,
      label,
      value,
      onChange,
      options = [],
      required = false,
      error,
      className = '',
      placeholder = 'Select an option'
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__field ".concat(className)
  }, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: id,
    className: "pro-form__field-label"
  }, label, required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-required"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("select", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    className: "pro-form__field-select ".concat(error ? 'pro-form__field-select--error' : ''),
    required: required
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("option", {
    value: ""
  }, placeholder), options.map(option => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("option", {
    key: option.value,
    value: option.value
  }, option.label))), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-error"
  }, error));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Select);

/***/ }),

/***/ "./js/components/react/form-components/TextInput.js":
/*!**********************************************************!*\
  !*** ./js/components/react/form-components/TextInput.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/extends */ "./node_modules/@babel/runtime/helpers/esm/extends.js");
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var _excluded = ["id", "name", "label", "type", "value", "onChange", "placeholder", "required", "error", "className"];

var TextInput = _ref => {
  var {
      id,
      name,
      label,
      type = 'text',
      value,
      onChange,
      placeholder,
      required = false,
      error,
      className = ''
    } = _ref,
    props = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__["default"])(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__field ".concat(className)
  }, label && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("label", {
    htmlFor: id,
    className: "pro-form__field-label"
  }, label, required && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-required"
  }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("input", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_0__["default"])({
    type: type,
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    className: "pro-form__field-input ".concat(error ? 'pro-form__field-input--error' : ''),
    required: required
  }, props)), error && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__field-error"
  }, error));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (TextInput);

/***/ }),

/***/ "./js/components/react/frequency-options.js":
/*!**************************************************!*\
  !*** ./js/components/react/frequency-options.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./tooltip */ "./js/components/react/tooltip.js");


// import 'StyleComponents/variant-options.scss';

var FrequencyOptions = _ref => {
  var {
    sellingplan,
    selectedSellingPlan,
    onUpdate,
    subscriptionPlan
  } = _ref;
  var [showFrequencyOption, setShowFrequencyOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var [showTooltip, setShowTooltip] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  var extractFrequency = frequency => {
    if (frequency != selectedSellingPlan.frequency) {
      var [deliveryText] = frequency.split(',');
      if (!deliveryText) return;
      return deliveryText;
    }
  };
  document.addEventListener('click', ev => {
    var target = ev.target.closest('.dropdown_content');
    if (!target) {
      setShowFrequencyOption(false);
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency-container__freq-label variant-container__opt-label"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency-container__freq-options variant-container__var-options"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", null, "Deliver every: "), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    class: "dropdown_content",
    onClick: () => setShowFrequencyOption(!showFrequencyOption)
  }, selectedSellingPlan.frequency, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: showFrequencyOption ? 'dropdownOpen' : 'dropdownClose'
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "7",
    viewBox: "0 0 10 7",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "0.707107",
    y1: "1.29289",
    x2: "5.70711",
    y2: "6.29289",
    stroke: "#282FEE",
    "stroke-width": "2"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.29289",
    y1: "6.29289",
    x2: "9.29289",
    y2: "1.29289",
    stroke: "#282FEE",
    "stroke-width": "2"
  }))), showFrequencyOption && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "frequency_options"
  }, sellingplan.length && sellingplan.map((sellplan, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    key: index,
    className: "frequency-container__freq-wrapper ".concat(selectedSellingPlan.id === sellplan.id ? 'active' : ''),
    onClick: () => {
      onUpdate(sellplan);
      setShowFrequencyOption(false);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
    className: "frequency-container__freq-name variant-container__var-name"
  }, extractFrequency(sellplan.frequency)))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip_container",
    onClick: () => setShowTooltip(!showTooltip)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "17",
    viewBox: "0 0 17 17",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z",
    fill: "#E8FF5C"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M17 8.5C17 13.1944 13.1944 17 8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5ZM8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z",
    fill: "#282FEE"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M7.77042 10.42V8.53601C8.45842 8.50401 8.99842 8.35601 9.39042 8.09201C9.78242 7.82001 9.97842 7.41201 9.97842 6.86801V6.70001C9.97842 6.25201 9.84242 5.91601 9.57042 5.69201C9.30642 5.46801 8.94242 5.35601 8.47842 5.35601C7.99842 5.35601 7.61442 5.48801 7.32642 5.75201C7.03842 6.01601 6.83842 6.35201 6.72642 6.76001L5.82642 6.42401C5.90642 6.16001 6.01842 5.91201 6.16242 5.68001C6.30642 5.44001 6.48642 5.23201 6.70242 5.05601C6.92642 4.88001 7.18642 4.74001 7.48242 4.63601C7.78642 4.53201 8.13042 4.48001 8.51442 4.48001C8.89842 4.48001 9.24242 4.53601 9.54642 4.64801C9.85842 4.75201 10.1224 4.90401 10.3384 5.10401C10.5544 5.29601 10.7224 5.53201 10.8424 5.81201C10.9624 6.09201 11.0224 6.40401 11.0224 6.74801C11.0224 7.12401 10.9544 7.45601 10.8184 7.74401C10.6824 8.02401 10.5064 8.26401 10.2904 8.46401C10.0744 8.66401 9.82642 8.82801 9.54642 8.95601C9.27442 9.07601 8.99842 9.16001 8.71842 9.20801V10.42H7.77042ZM8.28642 13.108C7.95842 13.108 7.72642 13.04 7.59042 12.904C7.46242 12.768 7.39842 12.596 7.39842 12.388V12.172C7.39842 11.964 7.46242 11.792 7.59042 11.656C7.72642 11.52 7.95842 11.452 8.28642 11.452C8.61442 11.452 8.84242 11.52 8.97042 11.656C9.10642 11.792 9.17442 11.964 9.17442 12.172V12.388C9.17442 12.596 9.10642 12.768 8.97042 12.904C8.84242 13.04 8.61442 13.108 8.28642 13.108Z",
    fill: "#282FEE"
  })), showTooltip && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_tooltip__WEBPACK_IMPORTED_MODULE_1__["default"], {
    setShowTooltip: showTooltip,
    subscriptionPlan: subscriptionPlan
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FrequencyOptions);

/***/ }),

/***/ "./js/components/react/onetime-options.js":
/*!************************************************!*\
  !*** ./js/components/react/onetime-options.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var OnetimeOptions = _ref => {
  var {
    selectedVariant,
    onUpdate,
    purchaseType
  } = _ref;
  console.log('selectedVariant..', selectedVariant);
  var {
    price,
    compareAtPrice,
    OriginalCompareAtPrice
  } = selectedVariant;
  // Remove dollar signs and parse the values to floats
  var numPriceWithoutCurrency = parseFloat(price.replace('$', '')) || 0;
  var compareAtPriceWithoutCurrency = parseFloat(compareAtPrice.replace('$', '')) || 0;
  var OriginalComparePrice = parseFloat(OriginalCompareAtPrice.replace('$', '')) || 0;
  var showDiscountedPrice = compareAtPriceWithoutCurrency > numPriceWithoutCurrency;
  var finalCompareAtPrice = compareAtPrice;
  if (!showDiscountedPrice) {
    finalCompareAtPrice = OriginalCompareAtPrice;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "onetime-container__onetime-wrapper variant-container__var-wrapper ".concat(purchaseType === 'onetime' ? 'active' : ''),
    onClick: () => {
      onUpdate("onetime");
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "onetime-container__onetime-label"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    className: "".concat(purchaseType == 'onetime' ? 'active' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.61589",
    y1: "6.67991",
    x2: "9.61589",
    y2: "0.679908",
    stroke: "white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.64645",
    y1: "7.35355",
    x2: "1.11091",
    y2: "3.81802",
    stroke: "white"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "One-time Purchase")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "onetime-container__oneTime-Price"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "sub-compare-at-price"
  }, finalCompareAtPrice), "\xA0", price)));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OnetimeOptions);

/***/ }),

/***/ "./js/components/react/pro-form.js":
/*!*****************************************!*\
  !*** ./js/components/react/pro-form.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! framer-motion */ "./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs");
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! html2canvas */ "./node_modules/html2canvas/dist/html2canvas.js");
/* harmony import */ var html2canvas__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(html2canvas__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! libphonenumber-js */ "./node_modules/libphonenumber-js/min/exports/parsePhoneNumberWithError.js");
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! libphonenumber-js */ "./node_modules/libphonenumber-js/min/exports/isValidPhoneNumber.js");
/* harmony import */ var country_state_city__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! country-state-city */ "./node_modules/country-state-city/lib/country.js");
/* harmony import */ var country_state_city__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! country-state-city */ "./node_modules/country-state-city/lib/state.js");
/* harmony import */ var pdfjs_dist__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pdfjs-dist */ "./node_modules/pdfjs-dist/build/pdf.mjs");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/TextInput.js");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/Select.js");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/Checkbox.js");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/FileUpload.js");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/FieldGroup.js");
/* harmony import */ var _form_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./form-components */ "./js/components/react/form-components/DateGroup.js");


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








// Utility function to generate a unique professional ID
var generateProfessionalId = () => {
  var timestamp = Date.now().toString(36).slice(-4).toUpperCase();
  var randomPart = Math.random().toString(36).substring(2, 6).toUpperCase();
  return "PRO-".concat(timestamp, "-").concat(randomPart);
};
var ProForm = _ref => {
  var _shopifyData$agreemen3, _shopifyData$agreemen4, _shopifyData$agreemen1, _shopifyData$agreemen10;
  var {
    shopifyData
  } = _ref;
  // Get customizable texts with fallbacks
  var texts = (shopifyData === null || shopifyData === void 0 ? void 0 : shopifyData.texts) || {};

  // Helper function to get label text (for non-text inputs)
  var getLabelText = fieldKey => {
    return texts[fieldKey] || null;
  };

  // Helper function to get placeholder text (for text inputs)
  var getPlaceholderText = fieldKey => {
    return texts[fieldKey] || null;
  };

  // Function to sync billing fields to shipping fields
  var syncBillingToShipping = billingData => {
    return {
      shippingFirstName: billingData.firstName,
      shippingLastName: billingData.lastName,
      shippingCompanyAttention: billingData.companyAttention,
      shippingAddress: billingData.address,
      shippingApartment: billingData.apartment,
      shippingCity: billingData.city,
      shippingState: billingData.state,
      shippingZipCode: billingData.zipCode,
      shippingCountry: billingData.country,
      shippingPhoneCountry: billingData.phoneCountry,
      shippingPhone: billingData.phone
    };
  };
  var [formData, setFormData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
    // Contact Information
    email: '',
    companyName: '',
    parevaSalesAgentName: '',
    country: '',
    firstName: '',
    lastName: '',
    companyAttention: '',
    address: '',
    apartment: '',
    city: '',
    state: '',
    zipCode: '',
    phoneCountry: '',
    phone: '',
    // Professional Information
    websiteUrl: '',
    professionalLicense: '',
    licenseState: '',
    licenseExpiration: {
      month: '',
      day: '',
      year: ''
    },
    professionalAffiliations: '',
    otherAffiliations: '',
    businessLicense: '',
    businessLicenseFile: null,
    licenseNumber: '',
    salesTaxExemption: '',
    salesTaxFile: null,
    howDidYouHear: '',
    otherSource: '',
    // Agreement checkboxes
    sameAsBilling: true,
    receiveCommunications: false,
    onlineSellerAgreement: false,
    purchaseTermsAgreement: false,
    // Shipping Address (when different from billing)
    shippingFirstName: '',
    shippingLastName: '',
    shippingCompanyAttention: '',
    shippingAddress: '',
    shippingApartment: '',
    shippingCity: '',
    shippingState: '',
    shippingZipCode: '',
    shippingCountry: '',
    shippingPhoneCountry: '',
    shippingPhone: ''
  });
  var [errors, setErrors] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
  var [isSubmitting, setIsSubmitting] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [isSuccess, setIsSuccess] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [screenshot1, setScreenshot1] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var [screenshot2, setScreenshot2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
  var [userIP, setUserIP] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('');
  var [availableStates, setAvailableStates] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
  var [pdfContent1, setPdfContent1] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('');
  var [pdfContent2, setPdfContent2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)('');
  var [isPdfLoading1, setIsPdfLoading1] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
  var [isPdfLoading2, setIsPdfLoading2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);

  // Configure PDF.js worker
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    // Use the correct worker file from pdfjs-dist
    pdfjs_dist__WEBPACK_IMPORTED_MODULE_9__.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs';
  }, []);

  // Get user IP address
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    fetch('https://api.ipify.org?format=json').then(response => response.json()).then(data => setUserIP(data.ip)).catch(() => setUserIP('Unable to determine IP'));
  }, []);

  // Load PDF content on component mount
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(() => {
    var _shopifyData$agreemen, _shopifyData$agreemen2;
    console.log('shopifyData', shopifyData);
    // Load Agreement 1 PDF
    if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen = shopifyData.agreement1) !== null && _shopifyData$agreemen !== void 0 && _shopifyData$agreemen.pdfUrl) {
      loadPdfContent1(shopifyData.agreement1.pdfUrl);
    }
    // Load Agreement 2 PDF
    if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen2 = shopifyData.agreement2) !== null && _shopifyData$agreemen2 !== void 0 && _shopifyData$agreemen2.pdfUrl) {
      loadPdfContent2(shopifyData.agreement2.pdfUrl);
    }
  }, [shopifyData === null || shopifyData === void 0 || (_shopifyData$agreemen3 = shopifyData.agreement1) === null || _shopifyData$agreemen3 === void 0 ? void 0 : _shopifyData$agreemen3.pdfUrl, shopifyData === null || shopifyData === void 0 || (_shopifyData$agreemen4 = shopifyData.agreement2) === null || _shopifyData$agreemen4 === void 0 ? void 0 : _shopifyData$agreemen4.pdfUrl]);

  // Function to load PDF content 1 and render as HTML
  var loadPdfContent1 = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (pdfUrl) {
      setIsPdfLoading1(true);
      try {
        var pdf = yield pdfjs_dist__WEBPACK_IMPORTED_MODULE_9__.getDocument(pdfUrl).promise;
        var formattedContent = '';

        // Extract text from all pages with formatting
        var _loop = function* _loop() {
          var page = yield pdf.getPage(pageNum);
          var textContent = yield page.getTextContent();

          // Process text items to detect headings, links, and formatting
          var pageContent = '';
          var currentLine = '';
          var lastY = null;
          var currentFontSize = 12;
          var currentIsBold = false;
          var currentIsItalic = false;
          textContent.items.forEach((item, index) => {
            var text = item.str;
            var fontSize = item.transform ? item.transform[0] : 12;
            var isBold = item.fontName && item.fontName.includes('Bold');
            var isItalic = item.fontName && item.fontName.includes('Italic');

            // Detect line breaks
            if (lastY !== null && Math.abs(item.transform[5] - lastY) > 5) {
              if (currentLine.trim() && !isPageNumber(currentLine.trim())) {
                pageContent += formatTextLine(currentLine.trim(), currentFontSize, currentIsBold, currentIsItalic) + '\n';
              }
              currentLine = text;
              currentFontSize = fontSize;
              currentIsBold = isBold;
              currentIsItalic = isItalic;
            } else {
              currentLine += text;
              // Update formatting for the current line
              currentFontSize = fontSize;
              currentIsBold = isBold;
              currentIsItalic = isItalic;
            }
            lastY = item.transform[5];
          });

          // Add the last line
          if (currentLine.trim() && !isPageNumber(currentLine.trim())) {
            pageContent += formatTextLine(currentLine.trim(), currentFontSize, currentIsBold, currentIsItalic) + '\n';
          }
          formattedContent += pageContent + '\n\n';
        };
        for (var pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          yield* _loop();
        }
        setPdfContent1(formattedContent);
      } catch (error) {
        console.error('Error loading PDF 1:', error);
        setPdfContent1('Error loading PDF content');
      } finally {
        setIsPdfLoading1(false);
      }
    });
    return function loadPdfContent1(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Function to load PDF content 2 and render as HTML
  var loadPdfContent2 = /*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (pdfUrl) {
      setIsPdfLoading2(true);
      try {
        var pdf = yield pdfjs_dist__WEBPACK_IMPORTED_MODULE_9__.getDocument(pdfUrl).promise;
        var formattedContent = '';

        // Extract text from all pages with formatting
        var _loop2 = function* _loop2() {
          var page = yield pdf.getPage(pageNum);
          var textContent = yield page.getTextContent();

          // Process text items to detect headings, links, and formatting
          var pageContent = '';
          var currentLine = '';
          var lastY = null;
          var currentFontSize = 12;
          var currentIsBold = false;
          var currentIsItalic = false;
          textContent.items.forEach((item, index) => {
            var text = item.str;
            var fontSize = item.transform ? item.transform[0] : 12;
            var isBold = item.fontName && item.fontName.includes('Bold');
            var isItalic = item.fontName && item.fontName.includes('Italic');

            // Detect line breaks
            if (lastY !== null && Math.abs(item.transform[5] - lastY) > 5) {
              if (currentLine.trim() && !isPageNumber(currentLine.trim())) {
                pageContent += formatTextLine(currentLine.trim(), currentFontSize, currentIsBold, currentIsItalic) + '\n';
              }
              currentLine = text;
              currentFontSize = fontSize;
              currentIsBold = isBold;
              currentIsItalic = isItalic;
            } else {
              currentLine += text;
              // Update formatting for the current line
              currentFontSize = fontSize;
              currentIsBold = isBold;
              currentIsItalic = isItalic;
            }
            lastY = item.transform[5];
          });

          // Add the last line
          if (currentLine.trim() && !isPageNumber(currentLine.trim())) {
            pageContent += formatTextLine(currentLine.trim(), currentFontSize, currentIsBold, currentIsItalic) + '\n';
          }
          formattedContent += pageContent + '\n\n';
        };
        for (var pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          yield* _loop2();
        }
        setPdfContent2(formattedContent);
      } catch (error) {
        console.error('Error loading PDF 2:', error);
        setPdfContent2('Error loading PDF content');
      } finally {
        setIsPdfLoading2(false);
      }
    });
    return function loadPdfContent2(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  // Helper function to check if text is a page number (e.g., "Page 1 of 3")
  var isPageNumber = text => {
    return /^page\s+\d+\s+of\s+\d+$/i.test(text.trim());
  };

  // Helper function to format text lines
  var formatTextLine = (text, fontSize, isBold, isItalic) => {
    // Detect headings (larger font size, bold, or all caps)
    if (fontSize > 14 || isBold || text === text.toUpperCase()) {
      return "<h3 style=\"font-size: ".concat(fontSize, "px; font-weight: bold; margin: 20px 0 10px 0; color: #333;\">").concat(text, "</h3>");
    }

    // Detect standalone URLs only (text that starts with http or www and is primarily a URL)
    if (text.match(/^(https?:\/\/|www\.)\S+$/)) {
      return "<p style=\"margin: 5px 0;\"><a href=\"".concat(text, "\" target=\"_blank\" style=\"color: #007bff; text-decoration: underline;\">").concat(text, "</a></p>");
    }

    // Detect numbered lists
    if (text.match(/^\d+\./)) {
      return "<p style=\"margin: 5px 0; padding-left: 20px;\">".concat(text, "</p>");
    }

    // Detect bullet points
    if (text.match(/^[•·▪▫]/)) {
      return "<p style=\"margin: 5px 0; padding-left: 20px;\">".concat(text, "</p>");
    }

    // Regular paragraphs
    return "<p style=\"margin: 5px 0; line-height: 1.5;\">".concat(text, "</p>");
  };
  var handleInputChange = (field, value) => {
    setFormData(prev => {
      var newData = _objectSpread(_objectSpread({}, prev), {}, {
        [field]: value
      });

      // If sameAsBilling is true and a billing field is changed, update corresponding shipping field
      if (prev.sameAsBilling) {
        var billingToShippingMap = {
          'firstName': 'shippingFirstName',
          'lastName': 'shippingLastName',
          'companyAttention': 'shippingCompanyAttention',
          'address': 'shippingAddress',
          'apartment': 'shippingApartment',
          'city': 'shippingCity',
          'state': 'shippingState',
          'zipCode': 'shippingZipCode',
          'country': 'shippingCountry',
          'phoneCountry': 'shippingPhoneCountry',
          'phone': 'shippingPhone'
        };
        if (billingToShippingMap[field]) {
          newData[billingToShippingMap[field]] = value;
        }
      }
      return newData;
    });
    if (errors[field]) {
      setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [field]: ''
      }));
    }

    // Clear DateGroup errors when all date fields are filled
    if (field === 'licenseExpiration') {
      var {
        month,
        day,
        year
      } = value;
      if (month && day && year) {
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          licenseExpirationMonth: '',
          licenseExpirationDay: '',
          licenseExpirationYear: ''
        }));
      }
    }

    // Auto-update phone country and states when country is selected (value is now ISO code)
    if (field === 'country') {
      // Find country from library using ISO code
      var countryFromPackage = country_state_city__WEBPACK_IMPORTED_MODULE_7__["default"].getAllCountries().find(country => country.isoCode === value);
      // Find country from our options to get dial_code
      var selectedCountry = countryFromPackage ? countryOptions.find(option => option.name === countryFromPackage.name) : null;
      if (selectedCountry && countryFromPackage) {
        // Find the matching phone country option using ISO code format
        var matchingPhoneCountry = "".concat(value, "|").concat(selectedCountry.dial_code);
        setFormData(prev => {
          var newData = _objectSpread(_objectSpread({}, prev), {}, {
            phoneCountry: matchingPhoneCountry
          });

          // If sameAsBilling is true, also update shipping country
          if (prev.sameAsBilling) {
            newData.shippingCountry = value;
          }
          return newData;
        });

        // Update available states based on selected country
        var states = country_state_city__WEBPACK_IMPORTED_MODULE_8__["default"].getStatesOfCountry(value);
        var stateOptions = states.map(state => ({
          value: state.isoCode,
          label: state.name,
          name: state.name
        }));
        setAvailableStates(stateOptions);
      } else {
        setAvailableStates([]);
      }
    }

    // Real-time validation
    if (field === 'phone' || field === 'phoneCountry') {
      validatePhoneNumber(value, field);
    } else if (field === 'email') {
      validateEmail(value);
    }

    // Handle sameAsBilling checkbox change
    if (field === 'sameAsBilling') {
      if (value === true) {
        // When checked, sync all billing fields to shipping fields
        setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [field]: value
        }, syncBillingToShipping(prev)));
      } else {
        // When unchecked, clear shipping fields
        setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [field]: value,
          shippingFirstName: '',
          shippingLastName: '',
          shippingCompanyAttention: '',
          shippingAddress: '',
          shippingApartment: '',
          shippingCity: '',
          shippingState: '',
          shippingZipCode: '',
          shippingCountry: '',
          shippingPhoneCountry: '',
          shippingPhone: ''
        }));
      }
    }

    // Auto-capture screenshot when each agreement checkbox is clicked
    if (field === 'onlineSellerAgreement') {
      if (value) {
        // Capture screenshot of Agreement 1 section when checkbox is checked
        setTimeout(() => {
          captureScreenshot(1);
        }, 500); // Small delay to ensure UI is updated
      }
    }
    if (field === 'purchaseTermsAgreement') {
      if (value) {
        // Capture screenshot of Agreement 2 section when checkbox is checked
        setTimeout(() => {
          captureScreenshot(2);
        }, 500); // Small delay to ensure UI is updated
      }
    }
  };
  var validateEmail = email => {
    if (email) {
      var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (!emailRegex.test(email)) {
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          email: 'Please enter a valid email address'
        }));
      } else {
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          email: ''
        }));
      }
    }
  };
  var getFirstError = () => {
    var errorFields = Object.keys(errors);
    if (errorFields.length > 0) {
      return errors[errorFields[0]];
    }
    return '';
  };
  var smoothScrollToElement = element => {
    if (!element) return;
    var elementRect = element.getBoundingClientRect();
    var absoluteElementTop = elementRect.top + window.pageYOffset;
    var middle = absoluteElementTop - window.innerHeight / 2;
    window.scrollTo({
      top: middle,
      behavior: 'smooth'
    });

    // Focus the element after a short delay to ensure scroll completes
    setTimeout(() => {
      element.focus();
    }, 300);
  };
  var scrollToFirstError = function scrollToFirstError() {
    var errorsToCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : errors;
    // Find the first field with an error
    var errorFields = Object.keys(errorsToCheck);
    if (errorFields.length === 0) return;
    var firstErrorField = errorFields[0];

    // Try to find the input element by name attribute first (since name is always required)
    var inputByName = document.querySelector("[name=\"".concat(firstErrorField, "\"]"));
    if (inputByName) {
      smoothScrollToElement(inputByName);
      return;
    }

    // If not found by name, try to find by ID as fallback
    var inputElement = document.getElementById(firstErrorField);
    if (inputElement) {
      smoothScrollToElement(inputElement);
      return;
    }

    // If still not found, scroll to the error message display area
    var errorDisplay = document.querySelector('.pro-form__first-error');
    if (errorDisplay) {
      smoothScrollToElement(errorDisplay);
    }
  };
  var validatePhoneNumber = (value, field) => {
    if (field === 'phone' && formData.phoneCountry && value) {
      try {
        // Extract dial code from the new format (country|dial_code)
        var dialCode = formData.phoneCountry.includes('|') ? formData.phoneCountry.split('|')[1] : formData.phoneCountry;
        var fullPhoneNumber = "".concat(dialCode).concat(value);
        if (!(0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_6__.isValidPhoneNumber)(fullPhoneNumber)) {
          setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
            phone: 'Please enter a valid phone number'
          }));
        } else {
          setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
            phone: ''
          }));
        }
      } catch (error) {
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          phone: 'Please enter a valid phone number'
        }));
      }
    } else if (field === 'phoneCountry' && formData.phone && value) {
      try {
        // Extract dial code from the new format (country|dial_code)
        var _dialCode = value.includes('|') ? value.split('|')[1] : value;
        var _fullPhoneNumber = "".concat(_dialCode).concat(formData.phone);
        if (!(0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_6__.isValidPhoneNumber)(_fullPhoneNumber)) {
          setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
            phone: 'Please enter a valid phone number'
          }));
        } else {
          setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
            phone: ''
          }));
        }
      } catch (error) {
        setErrors(prev => _objectSpread(_objectSpread({}, prev), {}, {
          phone: 'Please enter a valid phone number'
        }));
      }
    }
  };
  var handleFileUpload = (field, file) => {
    setFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [field]: file
    }));
  };
  var captureScreenshot = /*#__PURE__*/function () {
    var _ref4 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (agreementNumber) {
      try {
        // Target the specific agreement section based on agreement number
        var agreementSection = document.querySelector(".pro-form__agreement-".concat(agreementNumber));
        var targetElement = agreementSection || document.body;
        var canvas = yield html2canvas__WEBPACK_IMPORTED_MODULE_4___default()(targetElement, {
          useCORS: true,
          allowTaint: true,
          scale: 0.8,
          scrollX: 0,
          scrollY: 0,
          width: targetElement.scrollWidth,
          height: targetElement.scrollHeight
        });
        canvas.toBlob(blob => {
          if (agreementNumber === 1) {
            setScreenshot1(blob);
          } else if (agreementNumber === 2) {
            setScreenshot2(blob);
          }
        }, 'image/png');
      } catch (error) {
        console.error("Screenshot capture failed for agreement ".concat(agreementNumber, ":"), error);
      }
    });
    return function captureScreenshot(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var validateForm = () => {
    var newErrors = {};

    // Required fields validation
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.companyName) newErrors.companyName = 'Company name is required';
    if (!formData.country) newErrors.country = 'Country is required';
    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.lastName) newErrors.lastName = 'Last name is required';
    if (!formData.address) newErrors.address = 'Address is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.state) newErrors.state = 'State is required';
    if (!formData.zipCode) newErrors.zipCode = 'ZIP code is required';
    if (!formData.phone) newErrors.phone = 'Phone is required';
    if (!formData.professionalLicense) newErrors.professionalLicense = 'Professional license is required';
    if (!formData.licenseState) newErrors.licenseState = 'License state is required';
    if (!formData.licenseExpiration.month) newErrors.licenseExpirationMonth = 'Expiration month is required';
    if (!formData.licenseExpiration.day) newErrors.licenseExpirationDay = 'Expiration day is required';
    if (!formData.licenseExpiration.year) newErrors.licenseExpirationYear = 'Expiration year is required';

    // Email validation
    if (formData.email) {
      var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = 'Please enter a valid email address';
      }
    }

    // Phone number validation using libphonenumber-js
    if (formData.phone) {
      try {
        // Extract dial code from the new format (country|dial_code)
        var dialCode = formData.phoneCountry.includes('|') ? formData.phoneCountry.split('|')[1] : formData.phoneCountry;
        var fullPhoneNumber = "".concat(dialCode).concat(formData.phone);
        var phoneNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_5__.parsePhoneNumberWithError)(fullPhoneNumber);
        if (!(0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_6__.isValidPhoneNumber)(fullPhoneNumber)) {
          newErrors.phone = 'Please enter a valid phone number';
        } else if (phoneNumber && !phoneNumber.isValid()) {
          newErrors.phone = 'Please enter a valid phone number';
        }
      } catch (error) {
        newErrors.phone = 'Please enter a valid phone number';
      }
    }

    // Agreement validation
    if (!formData.onlineSellerAgreement) {
      newErrors.onlineSellerAgreement = 'Please accept the Online Seller Agreement';
    }
    if (!formData.purchaseTermsAgreement) {
      newErrors.purchaseTermsAgreement = 'Please accept the Purchase Terms Agreement';
    }
    setErrors(newErrors);

    // If there are errors, scroll to the first one after state update
    if (Object.keys(newErrors).length > 0) {
      setTimeout(() => {
        scrollToFirstError(newErrors);
      }, 100); // Small delay to ensure state is updated
    }
    return Object.keys(newErrors).length == 0;
  };

  // Helper function to format phone number as E.164
  var formatPhoneE164 = (phoneCountryValue, phoneNumber) => {
    if (!phoneCountryValue || !phoneNumber) return '';
    var dialCode = phoneCountryValue.includes('|') ? phoneCountryValue.split('|')[1] : phoneCountryValue;
    // Remove any non-digit characters from phone number
    var cleanPhone = phoneNumber.replace(/[^\d]/g, '');
    return "".concat(dialCode).concat(cleanPhone);
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* (e) {
      e.preventDefault();

      // Validate form on submit
      if (!validateForm()) {
        return;
      }
      setIsSubmitting(true);
      try {
        var _shopifyData$agreemen5, _shopifyData$agreemen6, _shopifyData$agreemen7, _shopifyData$agreemen8, _shopifyData$agreemen9, _shopifyData$agreemen0;
        var formDataToSubmit = new FormData();

        // Format phone numbers as E.164
        var phoneE164 = formatPhoneE164(formData.phoneCountry, formData.phone);
        var shippingPhoneE164 = formatPhoneE164(formData.shippingPhoneCountry, formData.shippingPhone);

        // Add all form fields
        Object.keys(formData).forEach(key => {
          // Skip phone-related fields - we'll add them separately with proper formatting
          if (['phone', 'phoneCountry', 'shippingPhone', 'shippingPhoneCountry'].includes(key)) {
            return;
          }
          if (formData[key] && typeof formData[key] === 'object' && !formData[key].name) {
            Object.keys(formData[key]).forEach(subKey => {
              formDataToSubmit.append("".concat(key, "_").concat(subKey), formData[key][subKey] || 'NA');
            });
          } else if (formData[key] && formData[key].name) {
            formDataToSubmit.append(key, formData[key]);
          } else {
            formDataToSubmit.append(key, formData[key] || 'NA');
          }
        });

        // Add phone fields with E.164 format
        formDataToSubmit.append('phone', phoneE164);
        if (shippingPhoneE164) {
          formDataToSubmit.append('shippingPhone', shippingPhoneE164);
        }

        // Generate and add unique professional ID
        var professionalId = generateProfessionalId();
        formDataToSubmit.append('professionalId', professionalId);

        // Add audit information
        formDataToSubmit.append('userIP', userIP);
        formDataToSubmit.append('timestamp', new Date().toISOString());
        formDataToSubmit.append('userName', "".concat(formData.firstName, " ").concat(formData.lastName));
        formDataToSubmit.append('userEmail', formData.email);

        // Add agreement versions
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen5 = shopifyData.agreement1) !== null && _shopifyData$agreemen5 !== void 0 && _shopifyData$agreemen5.version) {
          formDataToSubmit.append('agreement1Version', shopifyData.agreement1.version);
        }
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen6 = shopifyData.agreement2) !== null && _shopifyData$agreemen6 !== void 0 && _shopifyData$agreemen6.version) {
          formDataToSubmit.append('agreement2Version', shopifyData.agreement2.version);
        }

        // Add agreement titles
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen7 = shopifyData.agreement1) !== null && _shopifyData$agreemen7 !== void 0 && _shopifyData$agreemen7.title) {
          formDataToSubmit.append('agreement1Title', shopifyData.agreement1.title);
        }
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen8 = shopifyData.agreement2) !== null && _shopifyData$agreemen8 !== void 0 && _shopifyData$agreemen8.title) {
          formDataToSubmit.append('agreement2Title', shopifyData.agreement2.title);
        }

        // Add agreement PDF URLs
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen9 = shopifyData.agreement1) !== null && _shopifyData$agreemen9 !== void 0 && _shopifyData$agreemen9.pdfUrl) {
          formDataToSubmit.append('agreement1PdfUrl', shopifyData.agreement1.pdfUrl);
        }
        if (shopifyData !== null && shopifyData !== void 0 && (_shopifyData$agreemen0 = shopifyData.agreement2) !== null && _shopifyData$agreemen0 !== void 0 && _shopifyData$agreemen0.pdfUrl) {
          formDataToSubmit.append('agreement2PdfUrl', shopifyData.agreement2.pdfUrl);
        }

        // Add screenshots if captured
        if (screenshot1) {
          formDataToSubmit.append('screenshot1', screenshot1, 'agreement1_screenshot.png');
        }
        if (screenshot2) {
          formDataToSubmit.append('screenshot2', screenshot2, 'agreement2_screenshot.png');
        }
        var response = yield fetch(shopifyData.formspreeEndpoint, {
          method: 'POST',
          body: formDataToSubmit
        });
        setIsSuccess(true);
        // Scroll to top to show success message
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } catch (error) {
        setIsSuccess(true);
        // Scroll to top to show success message
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } finally {
        setIsSubmitting(false);
      }
    });
    return function handleSubmit(_x4) {
      return _ref5.apply(this, arguments);
    };
  }();

  // Success handler
  var handleGoHome = () => {
    window.location.href = '/';
  };

  // Form options
  var countryOptions = [{
    name: "Argentina",
    dial_code: "+54",
    flag: "🇷"
  }, {
    name: "Cambodia",
    dial_code: "+855",
    flag: "🇰🇭"
  }, {
    name: "Cameroon",
    dial_code: "+237",
    flag: "🇨🇲"
  }, {
    name: "Canada",
    dial_code: "+1",
    flag: "🇨🇦"
  }, {
    name: "Cape Verde",
    dial_code: "+238",
    flag: "🇨🇻"
  }, {
    name: "Cayman Islands",
    dial_code: "+1345",
    flag: "🇰🇾"
  }, {
    name: "Central African Republic",
    dial_code: "+236",
    flag: "🇨🇫"
  }, {
    name: "Chad",
    dial_code: "+235",
    flag: "🇹🇩"
  }, {
    name: "Chile",
    dial_code: "+56",
    flag: "🇨🇱"
  }, {
    name: "China",
    dial_code: "+86",
    flag: "🇨🇳"
  }, {
    name: "Colombia",
    dial_code: "+57",
    flag: "🇨🇴"
  }, {
    name: "Comoros",
    dial_code: "+269",
    flag: "🇰🇲"
  }, {
    name: "Congo",
    dial_code: "+242",
    flag: "🇨🇬"
  }, {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    flag: "🇨🇩"
  }, {
    name: "Cook Islands",
    dial_code: "+682",
    flag: "🇨🇰"
  }, {
    name: "Costa Rica",
    dial_code: "+506",
    flag: "🇨🇷"
  }, {
    name: "Croatia",
    dial_code: "+385",
    flag: "🇭🇷"
  }, {
    name: "Cuba",
    dial_code: "+53",
    flag: "🇨🇺"
  }, {
    name: "Cyprus",
    dial_code: "+357",
    flag: "🇨🇾"
  }, {
    name: "Czech Republic",
    dial_code: "+420",
    flag: "🇨🇿"
  }, {
    name: "Denmark",
    dial_code: "+45",
    flag: "🇩🇰"
  }, {
    name: "Djibouti",
    dial_code: "+253",
    flag: "🇩🇯"
  }, {
    name: "Dominica",
    dial_code: "+1767",
    flag: "🇩🇲"
  }, {
    name: "Dominican Republic",
    dial_code: "+1849",
    flag: "🇩🇴"
  }, {
    name: "Ecuador",
    dial_code: "+593",
    flag: "🇪🇨"
  }, {
    name: "Egypt",
    dial_code: "+20",
    flag: "🇪🇬"
  }, {
    name: "El Salvador",
    dial_code: "+503",
    flag: "🇸🇻"
  }, {
    name: "Estonia",
    dial_code: "+372",
    flag: "🇪🇪"
  }, {
    name: "Ethiopia",
    dial_code: "+251",
    flag: "🇪🇹"
  }, {
    name: "Fiji",
    dial_code: "+679",
    flag: "🇫🇯"
  }, {
    name: "Finland",
    dial_code: "+358",
    flag: "🇫🇮"
  }, {
    name: "France",
    dial_code: "+33",
    flag: "🇫🇷"
  }, {
    name: "Gabon",
    dial_code: "+241",
    flag: "🇬🇦"
  }, {
    name: "Gambia",
    dial_code: "+220",
    flag: "🇬🇲"
  }, {
    name: "Georgia",
    dial_code: "+995",
    flag: "🇬🇪"
  }, {
    name: "Germany",
    dial_code: "+49",
    flag: "🇩🇪"
  }, {
    name: "Ghana",
    dial_code: "+233",
    flag: "🇬🇭"
  }, {
    name: "Gibraltar",
    dial_code: "+350",
    flag: "🇬🇮"
  }, {
    name: "Greece",
    dial_code: "+30",
    flag: "🇬🇷"
  }, {
    name: "Greenland",
    dial_code: "+299",
    flag: "🇬🇱"
  }, {
    name: "Guatemala",
    dial_code: "+502",
    flag: "🇬🇹"
  }, {
    name: "Guinea",
    dial_code: "+224",
    flag: "🇬🇳"
  }, {
    name: "Guyana",
    dial_code: "+592",
    flag: "🇬🇾"
  }, {
    name: "Haiti",
    dial_code: "+509",
    flag: "🇭🇹"
  }, {
    name: "Honduras",
    dial_code: "+504",
    flag: "🇭🇳"
  }, {
    name: "Hong Kong",
    dial_code: "+852",
    flag: "🇭🇰"
  }, {
    name: "Hungary",
    dial_code: "+36",
    flag: "🇭🇺"
  }, {
    name: "Iceland",
    dial_code: "+354",
    flag: "🇮🇸"
  }, {
    name: "India",
    dial_code: "+91",
    flag: "🇮🇳"
  }, {
    name: "Indonesia",
    dial_code: "+62",
    flag: "🇮🇩"
  }, {
    name: "Iran",
    dial_code: "+98",
    flag: "🇮🇷"
  }, {
    name: "Iraq",
    dial_code: "+964",
    flag: "🇮🇶"
  }, {
    name: "Ireland",
    dial_code: "+353",
    flag: "🇮🇪"
  }, {
    name: "Israel",
    dial_code: "+972",
    flag: "🇮🇱"
  }, {
    name: "Italy",
    dial_code: "+39",
    flag: "🇮🇹"
  }, {
    name: "Jamaica",
    dial_code: "+1876",
    flag: "🇯🇲"
  }, {
    name: "Japan",
    dial_code: "+81",
    flag: "🇯🇵"
  }, {
    name: "Jordan",
    dial_code: "+962",
    flag: "🇯🇴"
  }, {
    name: "Kazakhstan",
    dial_code: "+7",
    flag: "🇰🇿"
  }, {
    name: "Kenya",
    dial_code: "+254",
    flag: "🇰🇪"
  }, {
    name: "Kuwait",
    dial_code: "+965",
    flag: "🇰🇼"
  }, {
    name: "Kyrgyzstan",
    dial_code: "+996",
    flag: "🇰🇬"
  }, {
    name: "Laos",
    dial_code: "+856",
    flag: "🇱🇦"
  }, {
    name: "Latvia",
    dial_code: "+371",
    flag: "🇱🇻"
  }, {
    name: "Lebanon",
    dial_code: "+961",
    flag: "🇱🇧"
  }, {
    name: "Lesotho",
    dial_code: "+266",
    flag: "🇱🇸"
  }, {
    name: "Liberia",
    dial_code: "+231",
    flag: "🇱🇷"
  }, {
    name: "Libya",
    dial_code: "+218",
    flag: "🇱🇾"
  }, {
    name: "Liechtenstein",
    dial_code: "+423",
    flag: "🇱🇮"
  }, {
    name: "Lithuania",
    dial_code: "+370",
    flag: "🇱🇹"
  }, {
    name: "Luxembourg",
    dial_code: "+352",
    flag: "🇱🇺"
  }, {
    name: "Macao",
    dial_code: "+853",
    flag: "🇲🇴"
  }, {
    name: "Madagascar",
    dial_code: "+261",
    flag: "🇲🇬"
  }, {
    name: "Malawi",
    dial_code: "+265",
    flag: "🇲🇼"
  }, {
    name: "Malaysia",
    dial_code: "+60",
    flag: "🇲🇾"
  }, {
    name: "Maldives",
    dial_code: "+960",
    flag: "🇲🇻"
  }, {
    name: "Mali",
    dial_code: "+223",
    flag: "🇲🇱"
  }, {
    name: "Malta",
    dial_code: "+356",
    flag: "🇲🇹"
  }, {
    name: "Mauritius",
    dial_code: "+230",
    flag: "🇲🇺"
  }, {
    name: "Mexico",
    dial_code: "+52",
    flag: "🇲🇽"
  }, {
    name: "Moldova",
    dial_code: "+373",
    flag: "🇲🇩"
  }, {
    name: "Monaco",
    dial_code: "+377",
    flag: "🇲🇨"
  }, {
    name: "Mongolia",
    dial_code: "+976",
    flag: "🇲🇳"
  }, {
    name: "Montenegro",
    dial_code: "+382",
    flag: "🇲🇪"
  }, {
    name: "Morocco",
    dial_code: "+212",
    flag: "🇲🇦"
  }, {
    name: "Mozambique",
    dial_code: "+258",
    flag: "🇲🇿"
  }, {
    name: "Myanmar",
    dial_code: "+95",
    flag: "🇲🇲"
  }, {
    name: "Namibia",
    dial_code: "+264",
    flag: "🇳🇦"
  }, {
    name: "Nepal",
    dial_code: "+977",
    flag: "🇳🇵"
  }, {
    name: "Netherlands",
    dial_code: "+31",
    flag: "🇳🇱"
  }, {
    name: "New Zealand",
    dial_code: "+64",
    flag: "🇳🇿"
  }, {
    name: "Nicaragua",
    dial_code: "+505",
    flag: "🇳🇮"
  }, {
    name: "Niger",
    dial_code: "+227",
    flag: "🇳🇪"
  }, {
    name: "Nigeria",
    dial_code: "+234",
    flag: "🇳🇬"
  }, {
    name: "North Macedonia",
    dial_code: "+389",
    flag: "🇲🇰"
  }, {
    name: "Norway",
    dial_code: "+47",
    flag: "🇳🇴"
  }, {
    name: "Oman",
    dial_code: "+968",
    flag: "🇴🇲"
  }, {
    name: "Pakistan",
    dial_code: "+92",
    flag: "🇵🇰"
  }, {
    name: "Panama",
    dial_code: "+507",
    flag: "🇵🇦"
  }, {
    name: "Papua New Guinea",
    dial_code: "+675",
    flag: "🇵🇬"
  }, {
    name: "Paraguay",
    dial_code: "+595",
    flag: "🇵🇾"
  }, {
    name: "Peru",
    dial_code: "+51",
    flag: "🇵🇪"
  }, {
    name: "Philippines",
    dial_code: "+63",
    flag: "🇵🇭"
  }, {
    name: "Poland",
    dial_code: "+48",
    flag: "🇵🇱"
  }, {
    name: "Portugal",
    dial_code: "+351",
    flag: "🇵🇹"
  }, {
    name: "Qatar",
    dial_code: "+974",
    flag: "🇶🇦"
  }, {
    name: "Romania",
    dial_code: "+40",
    flag: "🇷🇴"
  }, {
    name: "Russia",
    dial_code: "+7",
    flag: "🇷🇺"
  }, {
    name: "Rwanda",
    dial_code: "+250",
    flag: "🇷🇼"
  }, {
    name: "Saudi Arabia",
    dial_code: "+966",
    flag: "🇸🇦"
  }, {
    name: "Senegal",
    dial_code: "+221",
    flag: "🇸🇳"
  }, {
    name: "Serbia",
    dial_code: "+381",
    flag: "🇷🇸"
  }, {
    name: "Seychelles",
    dial_code: "+248",
    flag: "🇸🇨"
  }, {
    name: "Singapore",
    dial_code: "+65",
    flag: "🇸🇬"
  }, {
    name: "Slovakia",
    dial_code: "+421",
    flag: "🇸🇰"
  }, {
    name: "Slovenia",
    dial_code: "+386",
    flag: "🇸🇮"
  }, {
    name: "South Africa",
    dial_code: "+27",
    flag: "🇿🇦"
  }, {
    name: "South Korea",
    dial_code: "+82",
    flag: "🇰🇷"
  }, {
    name: "Spain",
    dial_code: "+34",
    flag: "🇪🇸"
  }, {
    name: "Sri Lanka",
    dial_code: "+94",
    flag: "🇱🇰"
  }, {
    name: "Sweden",
    dial_code: "+46",
    flag: "🇸🇪"
  }, {
    name: "Switzerland",
    dial_code: "+41",
    flag: "🇨🇭"
  }, {
    name: "Taiwan",
    dial_code: "+886",
    flag: "🇹🇼"
  }, {
    name: "Tanzania",
    dial_code: "+255",
    flag: "🇹🇿"
  }, {
    name: "Thailand",
    dial_code: "+66",
    flag: "🇹🇭"
  }, {
    name: "Tunisia",
    dial_code: "+216",
    flag: "🇹🇳"
  }, {
    name: "Turkey",
    dial_code: "+90",
    flag: "🇹🇷"
  }, {
    name: "Uganda",
    dial_code: "+256",
    flag: "🇺🇬"
  }, {
    name: "Ukraine",
    dial_code: "+380",
    flag: "🇺🇦"
  }, {
    name: "United Arab Emirates",
    dial_code: "+971",
    flag: "🇦🇪"
  }, {
    name: "United Kingdom",
    dial_code: "+44",
    flag: "🇬🇧"
  }, {
    name: "United States",
    dial_code: "+1",
    flag: "🇺🇸"
  }, {
    name: "Uruguay",
    dial_code: "+598",
    flag: "🇺🇾"
  }, {
    name: "Uzbekistan",
    dial_code: "+998",
    flag: "🇺🇿"
  }, {
    name: "Venezuela",
    dial_code: "+58",
    flag: "🇻🇪"
  }, {
    name: "Vietnam",
    dial_code: "+84",
    flag: "🇻🇳"
  }, {
    name: "Zambia",
    dial_code: "+260",
    flag: "🇿🇲"
  }, {
    name: "Zimbabwe",
    dial_code: "+263",
    flag: "🇿🇼"
  }];

  // Get all countries from library and create a lookup map
  var allCountriesFromLib = country_state_city__WEBPACK_IMPORTED_MODULE_7__["default"].getAllCountries();
  var countryIsoMap = allCountriesFromLib.reduce((acc, c) => {
    acc[c.name] = c.isoCode;
    return acc;
  }, {});

  // Convert country options to the format expected by Select component - using ISO code as value
  var countrySelectOptions = countryOptions.map(country => ({
    value: countryIsoMap[country.name] || country.name,
    label: "".concat(country.flag, " ").concat(country.name)
  }));

  // Phone country options - using ISO code + dial_code as unique key
  var phoneCountryOptions = countryOptions.map(country => ({
    value: "".concat(countryIsoMap[country.name] || country.name, "|").concat(country.dial_code),
    label: "".concat(country.flag, " ").concat(country.name, " (").concat(country.dial_code, ")")
  }));
  var professionalLicenseOptions = [{
    value: 'individual',
    label: 'Individual'
  }, {
    value: 'business',
    label: 'Business'
  }];
  var affiliationOptions = [{
    value: 'ASCP',
    label: 'ASCP'
  }, {
    value: 'ASDS',
    label: 'ASDS'
  }, {
    value: 'other',
    label: 'Other'
  }];
  var howDidYouHearOptions = [{
    value: 'trade_show',
    label: 'Trade Show'
  }, {
    value: 'google',
    label: 'Google'
  }, {
    value: 'tiktok',
    label: 'Tik Tok'
  }, {
    value: 'linkedin',
    label: 'Linkedin'
  }, {
    value: 'facebook',
    label: 'Facebook'
  }, {
    value: 'instagram',
    label: 'Instagram'
  }, {
    value: 'other',
    label: 'Other'
  }];

  // Success UI Component
  if (isSuccess) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "pro-form__success-container"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(framer_motion__WEBPACK_IMPORTED_MODULE_3__.motion.div, {
      className: "pro-form__success-content",
      initial: {
        opacity: 0,
        y: 20
      },
      animate: {
        opacity: 1,
        y: 0
      },
      transition: {
        duration: 0.5
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
      className: "pro-form__success-icon"
    }, "\u2705"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h2", {
      className: "pro-form__success-title"
    }, "Form Submitted Successfully!"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("p", {
      className: "pro-form__success-message"
    }, "Thank you for your submission. We have received your application and will review it shortly."), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
      onClick: handleGoHome,
      className: "pro-form__success-button"
    }, "Return to Home Page")));
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("form", {
    className: "pro-form__form"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h3", {
    className: "pro-form__section-title"
  }, "Contact Information"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "email",
    name: "email",
    placeholder: getPlaceholderText('emailLabel'),
    type: "email",
    value: formData.email,
    onChange: e => handleInputChange('email', e.target.value),
    required: true,
    error: errors.email
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "companyName",
    name: "companyName",
    placeholder: getPlaceholderText('companyNameLabel'),
    value: formData.companyName,
    onChange: e => handleInputChange('companyName', e.target.value),
    required: true,
    error: errors.companyName
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "parevaSalesAgentName",
    name: "parevaSalesAgentName",
    placeholder: "Pareva Sales Agent Name",
    value: formData.parevaSalesAgentName,
    onChange: e => handleInputChange('parevaSalesAgentName', e.target.value),
    error: errors.parevaSalesAgentName
  }), texts.streetAddressTitle && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h4", {
    className: "pro-form__subsection-title"
  }, texts.streetAddressTitle), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "country",
    name: "country",
    placeholder: getPlaceholderText('countryLabel'),
    value: formData.country,
    onChange: e => handleInputChange('country', e.target.value),
    options: countrySelectOptions,
    required: true,
    error: errors.country
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    columns: 2
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "firstName",
    name: "firstName",
    placeholder: getPlaceholderText('firstNameLabel'),
    value: formData.firstName,
    onChange: e => handleInputChange('firstName', e.target.value),
    required: true,
    error: errors.firstName
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "lastName",
    name: "lastName",
    placeholder: getPlaceholderText('lastNameLabel'),
    value: formData.lastName,
    onChange: e => handleInputChange('lastName', e.target.value),
    required: true,
    error: errors.lastName
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "companyAttention",
    name: "companyAttention",
    placeholder: getPlaceholderText('companyAttentionLabel'),
    value: formData.companyAttention,
    onChange: e => handleInputChange('companyAttention', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "address",
    name: "address",
    placeholder: getPlaceholderText('addressLabel'),
    value: formData.address,
    onChange: e => handleInputChange('address', e.target.value),
    required: true,
    error: errors.address
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "apartment",
    name: "apartment",
    placeholder: getPlaceholderText('apartmentLabel'),
    value: formData.apartment,
    onChange: e => handleInputChange('apartment', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    columns: 3
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "city",
    name: "city",
    placeholder: getPlaceholderText('cityLabel'),
    value: formData.city,
    onChange: e => handleInputChange('city', e.target.value),
    required: true,
    error: errors.city
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "state",
    name: "state",
    placeholder: getPlaceholderText('stateLabel'),
    value: formData.state,
    onChange: e => handleInputChange('state', e.target.value),
    options: availableStates,
    required: true,
    error: errors.state
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "zipCode",
    name: "zipCode",
    placeholder: getPlaceholderText('zipCodeLabel'),
    value: formData.zipCode,
    onChange: e => handleInputChange('zipCode', e.target.value),
    required: true,
    error: errors.zipCode
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    className: "pro-form__field-group--phone-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "phoneCountry",
    name: "phoneCountry",
    placeholder: getPlaceholderText('countryCodeLabel'),
    value: formData.phoneCountry,
    onChange: e => handleInputChange('phoneCountry', e.target.value),
    options: phoneCountryOptions,
    required: true,
    error: errors.phoneCountry
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "phone",
    name: "phone",
    placeholder: getPlaceholderText('phoneLabel'),
    type: "tel",
    value: formData.phone,
    onChange: e => handleInputChange('phone', e.target.value),
    required: true,
    error: errors.phone
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h4", {
    className: "pro-form__subsection-title"
  }, texts.shippingAddressHeading || "Company Shipping Address"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_12__["default"], {
    id: "sameAsBilling",
    name: "sameAsBilling",
    label: getLabelText('sameAsBillingLabel'),
    checked: formData.sameAsBilling,
    onChange: e => handleInputChange('sameAsBilling', e.target.checked)
  }), !formData.sameAsBilling && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__shipping-section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "shippingCountry",
    name: "shippingCountry",
    placeholder: getPlaceholderText('countryLabel'),
    value: formData.shippingCountry,
    onChange: e => handleInputChange('shippingCountry', e.target.value),
    options: countrySelectOptions,
    required: true,
    error: errors.shippingCountry
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    columns: 2
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingFirstName",
    name: "shippingFirstName",
    placeholder: getPlaceholderText('firstNameLabel'),
    value: formData.shippingFirstName,
    onChange: e => handleInputChange('shippingFirstName', e.target.value),
    required: true,
    error: errors.shippingFirstName
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingLastName",
    name: "shippingLastName",
    placeholder: getPlaceholderText('lastNameLabel'),
    value: formData.shippingLastName,
    onChange: e => handleInputChange('shippingLastName', e.target.value),
    required: true,
    error: errors.shippingLastName
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingCompanyAttention",
    name: "shippingCompanyAttention",
    placeholder: getPlaceholderText('companyAttentionLabel'),
    value: formData.shippingCompanyAttention,
    onChange: e => handleInputChange('shippingCompanyAttention', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingAddress",
    name: "shippingAddress",
    placeholder: getPlaceholderText('addressLabel'),
    value: formData.shippingAddress,
    onChange: e => handleInputChange('shippingAddress', e.target.value),
    required: true,
    error: errors.shippingAddress
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingApartment",
    name: "shippingApartment",
    placeholder: getPlaceholderText('apartmentLabel'),
    value: formData.shippingApartment,
    onChange: e => handleInputChange('shippingApartment', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    columns: 3
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingCity",
    name: "shippingCity",
    placeholder: getPlaceholderText('cityLabel'),
    value: formData.shippingCity,
    onChange: e => handleInputChange('shippingCity', e.target.value),
    required: true,
    error: errors.shippingCity
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "shippingState",
    name: "shippingState",
    placeholder: getPlaceholderText('stateLabel'),
    value: formData.shippingState,
    onChange: e => handleInputChange('shippingState', e.target.value),
    options: availableStates,
    required: true,
    error: errors.shippingState
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingZipCode",
    name: "shippingZipCode",
    placeholder: getPlaceholderText('zipCodeLabel'),
    value: formData.shippingZipCode,
    onChange: e => handleInputChange('shippingZipCode', e.target.value),
    required: true,
    error: errors.shippingZipCode
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_14__["default"], {
    columns: 2,
    className: "pro-form__field-group--phone-group"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "shippingPhoneCountry",
    name: "shippingPhoneCountry",
    placeholder: getPlaceholderText('countryCodeLabel'),
    value: formData.shippingPhoneCountry,
    onChange: e => handleInputChange('shippingPhoneCountry', e.target.value),
    options: phoneCountryOptions,
    required: true,
    error: errors.shippingPhoneCountry
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "shippingPhone",
    name: "shippingPhone",
    type: "tel",
    placeholder: getPlaceholderText('phoneLabel'),
    value: formData.shippingPhone,
    onChange: e => handleInputChange('shippingPhone', e.target.value),
    required: true,
    error: errors.shippingPhone
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h3", {
    className: "pro-form__section-title"
  }, "Professional Information"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "websiteUrl",
    name: "websiteUrl",
    label: getLabelText('websiteUrlLabel'),
    placeholder: getPlaceholderText('websiteUrlLabel'),
    type: "url",
    value: formData.websiteUrl,
    onChange: e => handleInputChange('websiteUrl', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "professionalLicense",
    name: "professionalLicense",
    label: getLabelText('professionalLicenseLabel'),
    placeholder: "Select Professional License",
    value: formData.professionalLicense,
    onChange: e => handleInputChange('professionalLicense', e.target.value),
    options: professionalLicenseOptions,
    required: true,
    error: errors.professionalLicense
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "licenseState",
    name: "licenseState",
    label: getLabelText('licenseStateLabel'),
    placeholder: "Select License State",
    value: formData.licenseState,
    onChange: e => handleInputChange('licenseState', e.target.value),
    options: availableStates.map(state => ({
      value: state.name,
      label: state.name,
      name: state.name
    })),
    required: true,
    error: errors.licenseState
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_15__["default"], {
    label: getLabelText('licenseExpirationLabel'),
    value: formData.licenseExpiration,
    onChange: handleInputChange.bind(null, 'licenseExpiration'),
    required: true,
    error: errors.licenseExpirationMonth || errors.licenseExpirationDay || errors.licenseExpirationYear
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "professionalAffiliations",
    name: "professionalAffiliations",
    label: getLabelText('professionalAffiliationsLabel'),
    placeholder: "Select Professional Affiliations",
    value: formData.professionalAffiliations,
    onChange: e => handleInputChange('professionalAffiliations', e.target.value),
    options: affiliationOptions
  }), formData.professionalAffiliations === 'other' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "otherAffiliations",
    name: "otherAffiliations",
    label: getLabelText('otherAffiliationsLabel'),
    placeholder: "Select Other Affiliations",
    value: formData.otherAffiliations,
    onChange: e => handleInputChange('otherAffiliations', e.target.value)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "businessLicense",
    name: "businessLicense",
    label: getLabelText('businessLicenseLabel'),
    placeholder: "Select Business License",
    value: formData.businessLicense,
    onChange: e => handleInputChange('businessLicense', e.target.value),
    options: [{
      value: 'yes',
      label: 'Yes'
    }, {
      value: 'no',
      label: 'No'
    }]
  }), formData.businessLicense === 'yes' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement((react__WEBPACK_IMPORTED_MODULE_2___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_13__["default"], {
    id: "businessLicenseFile",
    name: "businessLicenseFile",
    label: getLabelText('businessLicenseFileLabel'),
    value: formData.businessLicenseFile,
    onChange: file => handleFileUpload('businessLicenseFile', file),
    onRemove: () => handleFileUpload('businessLicenseFile', null),
    accept: ".pdf,.jpg,.jpeg,.png"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "licenseNumber",
    name: "licenseNumber",
    label: getLabelText('licenseNumberLabel'),
    placeholder: "Enter License Number",
    value: formData.licenseNumber,
    onChange: e => handleInputChange('licenseNumber', e.target.value)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "salesTaxExemption",
    name: "salesTaxExemption",
    label: getLabelText('salesTaxExemptionLabel'),
    placeholder: "Select Sales Tax Exemption",
    value: formData.salesTaxExemption,
    onChange: e => handleInputChange('salesTaxExemption', e.target.value),
    options: [{
      value: 'yes',
      label: 'Yes'
    }, {
      value: 'no',
      label: 'No'
    }]
  }), formData.salesTaxExemption === 'yes' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_13__["default"], {
    id: "salesTaxFile",
    name: "salesTaxFile",
    label: getLabelText('salesTaxFileLabel'),
    value: formData.salesTaxFile,
    onChange: file => handleFileUpload('salesTaxFile', file),
    onRemove: () => handleFileUpload('salesTaxFile', null),
    accept: ".pdf,.jpg,.jpeg,.png"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_11__["default"], {
    id: "howDidYouHear",
    name: "howDidYouHear",
    label: getLabelText('howDidYouHearLabel'),
    placeholder: "Select How Did You Hear",
    value: formData.howDidYouHear,
    onChange: e => handleInputChange('howDidYouHear', e.target.value),
    options: howDidYouHearOptions
  }), (formData.howDidYouHear === 'tradeshow' || formData.howDidYouHear === 'other') && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_10__["default"], {
    id: "otherSource",
    name: "otherSource",
    label: getLabelText('otherSourceLabel'),
    placeholder: "Enter Other Source",
    value: formData.otherSource,
    onChange: e => handleInputChange('otherSource', e.target.value)
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h3", {
    className: "pro-form__section-title"
  }, "Agreement & Terms"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_12__["default"], {
    id: "receiveCommunications",
    name: "receiveCommunications",
    label: getLabelText('receiveCommunicationsLabel'),
    checked: formData.receiveCommunications,
    onChange: e => handleInputChange('receiveCommunications', e.target.checked)
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-1 pro-form__agreement-section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h4", null, (shopifyData === null || shopifyData === void 0 || (_shopifyData$agreemen1 = shopifyData.agreement1) === null || _shopifyData$agreemen1 === void 0 ? void 0 : _shopifyData$agreemen1.title) || "Pareva Beauty Online Seller Agreement"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-viewer"
  }, isPdfLoading1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-loading"
  }, "Loading agreement...") : pdfContent1 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-content",
    dangerouslySetInnerHTML: {
      __html: pdfContent1
    },
    style: {
      maxHeight: '400px',
      overflowY: 'auto',
      padding: '15px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      backgroundColor: '#f9f9f9'
    }
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-loading"
  }, "No agreement content available"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-checkboxes"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_12__["default"], {
    id: "onlineSellerAgreement",
    name: "onlineSellerAgreement",
    label: getLabelText('onlineSellerAgreementLabel'),
    checked: formData.onlineSellerAgreement,
    onChange: e => handleInputChange('onlineSellerAgreement', e.target.checked),
    error: errors.onlineSellerAgreement
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-2 pro-form__agreement-section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("h4", null, (shopifyData === null || shopifyData === void 0 || (_shopifyData$agreemen10 = shopifyData.agreement2) === null || _shopifyData$agreemen10 === void 0 ? void 0 : _shopifyData$agreemen10.title) || "Pareva Beauty Purchase Terms Agreement"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-viewer"
  }, isPdfLoading2 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-loading"
  }, "Loading agreement...") : pdfContent2 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-content",
    dangerouslySetInnerHTML: {
      __html: pdfContent2
    },
    style: {
      maxHeight: '400px',
      overflowY: 'auto',
      padding: '15px',
      border: '1px solid #ddd',
      borderRadius: '4px',
      backgroundColor: '#f9f9f9'
    }
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__pdf-loading"
  }, "No agreement content available"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__agreement-checkboxes"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement(_form_components__WEBPACK_IMPORTED_MODULE_12__["default"], {
    id: "purchaseTermsAgreement",
    name: "purchaseTermsAgreement",
    label: getLabelText('purchaseTermsAgreementLabel'),
    checked: formData.purchaseTermsAgreement,
    onChange: e => handleInputChange('purchaseTermsAgreement', e.target.checked),
    error: errors.purchaseTermsAgreement
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__submit-section"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("button", {
    type: "button",
    onClick: handleSubmit,
    className: "pro-form__submit-btn",
    disabled: isSubmitting || !formData.onlineSellerAgreement || !formData.purchaseTermsAgreement || !screenshot1 || !screenshot2
  }, isSubmitting ? texts.submittingButtonText || 'Submitting...' : texts.submitButtonText || 'Submit'), getFirstError() && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("div", {
    className: "pro-form__first-error"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2___default().createElement("span", {
    className: "pro-form__error-text"
  }, getFirstError())))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProForm);

/***/ }),

/***/ "./js/components/react/pyramid-factual.js":
/*!************************************************!*\
  !*** ./js/components/react/pyramid-factual.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ResponsiveImage */ "./js/components/react/ResponsiveImage.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var FactualSection = _ref => {
  var _shopifyData$data;
  var {
    shopifyData
  } = _ref;
  console.log("Shopify Data:", shopifyData);
  var blocks = ((_shopifyData$data = shopifyData.data) === null || _shopifyData$data === void 0 ? void 0 : _shopifyData$data.blocks) || [];
  var blockCount = blocks.length;
  var imageArray = blocks.flatMap(block => {
    var _block$cards;
    return (_block$cards = block.cards) === null || _block$cards === void 0 ? void 0 : _block$cards.map(card => {
      var _block$image;
      return _objectSpread(_objectSpread({}, card), {}, {
        blockImage: (_block$image = block.image) === null || _block$image === void 0 ? void 0 : _block$image[0]
      });
    });
  });
  var [selectedBlock, setselectedBlock] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isFirstImageOpen, setIsFirstImageOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isSecondImageOpen, setIsSecondImageOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  var srcTokens = {
    replacementToken: "?width=90&height=90",
    dataSrcToken: "?width=width&height=height",
    srcToken: "?width=90&height=90"
  };
  var handleCardClick = card => {
    setselectedBlock(card);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (selectedBlock) {
      setIsFirstImageOpen(true);
    } else {
      setIsFirstImageOpen(false);
    }
  }, [selectedBlock]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var isMobileBreakpoint = matchMedia("(min-width: 768px)").matches ? false : true;
    setIsMobile(isMobileBreakpoint);
  }, []);
  var handleCloseImage = () => {
    setselectedBlock(false);
  };
  var handleNextImage = () => {
    setIsSecondImageOpen(true);
  };

  // useEffect(() => {
  //   if(isSecondImageOpen) {
  //     console.log(isMobile, "ismobile");
  //   }

  // }, [isSecondImageOpen])
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    console.log("data---", selectedBlock);
  }, [selectedBlock]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "container factual_container"
  }, blockCount > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "factual__section",
    style: {
      background: "".concat(shopifyData.data.background_color),
      display: "grid",
      gridTemplateColumns: "repeat(".concat(Math.min(blockCount, 2), ", 1fr)")
    }
  }, blocks.map((block, index) => {
    var _block$image2, _selectedBlock$imageS, _selectedBlock$imageS2, _selectedBlock$imageM, _selectedBlock$imageM2, _selectedBlock$imageM3, _selectedBlock$imageS3;
    var image = (_block$image2 = block.image) === null || _block$image2 === void 0 ? void 0 : _block$image2[0];
    var src = image === null || image === void 0 ? void 0 : image.src;
    var width = (image === null || image === void 0 ? void 0 : image.width) || 1920;
    var height = (image === null || image === void 0 ? void 0 : image.height) || 1080;
    var isFirstBlock = index === 0;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      key: index,
      className: "factual__item ".concat(isFirstBlock ? "factual__item--flex" : "", " ").concat(shopifyData.data.swipeMedia === "true" ? "factual__swap-block-mobile" : ""),
      style: {
        position: "relative"
      }
    }, isFirstBlock && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, block.url && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "text-image__button"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("a", {
      className: "button button__custom-button text__cta",
      href: block.url
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "btn-text button__btn-text"
    }, " ", block.button, " "))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__left"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__popup-image-desktop"
    }, selectedBlock && (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageSrc[0]) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__top-image",
      style: {
        position: 'absolute',
        top: 41,
        left: 0,
        width: '100%',
        zIndex: 5
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.59,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS = selectedBlock.imageSrc[0]) === null || _selectedBlock$imageS === void 0 ? void 0 : _selectedBlock$imageS.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), selectedBlock && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '10px',
        right: '0',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleCloseImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "71",
      height: "70",
      viewBox: "0 0 71 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "35.5",
      cy: "35",
      r: "17.5",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "27.8399",
      y1: "26.6601",
      x2: "41.9821",
      y2: "40.8022",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "41.9805",
      y1: "27.3321",
      x2: "27.8384",
      y2: "41.4742",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))), (selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS2 = selectedBlock.imageSrc[1]) === null || _selectedBlock$imageS2 === void 0 ? void 0 : _selectedBlock$imageS2.src) && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__next-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '19px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleNextImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "18",
      r: "17",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M13.7908 27.9548L24.3868 18.1175L13.7908 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__popup-image-mobile",
      style: {
        position: 'relative'
      }
    }, selectedBlock && (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageMobile[0]) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__top-image",
      style: {
        position: 'absolute',
        top: '42px',
        left: 0,
        width: '100%',
        zIndex: 5
      }
    }, isMobile && isSecondImageOpen ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.582,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM = selectedBlock.imageMobile[1]) === null || _selectedBlock$imageM === void 0 ? void 0 : _selectedBlock$imageM.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '17px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: () => setIsSecondImageOpen(false)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "17.5",
      r: "17",
      transform: "matrix(-1 0 0 1 35 0.5)",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M21.2092 27.9548L10.6132 18.1175L21.2092 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    })))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.582,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM2 = selectedBlock.imageMobile[0]) === null || _selectedBlock$imageM2 === void 0 ? void 0 : _selectedBlock$imageM2.src,
        width,
        height
      },
      srcTokens: srcTokens
    }), selectedBlock && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '-10px',
        right: '-10px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleCloseImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "71",
      height: "70",
      viewBox: "0 0 71 70",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "35.5",
      cy: "35",
      r: "17.5",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "27.8399",
      y1: "26.6601",
      x2: "41.9821",
      y2: "40.8022",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("line", {
      x1: "41.9805",
      y1: "27.3321",
      x2: "27.8384",
      y2: "41.4742",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))), (selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.imageMobile) && (selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageM3 = selectedBlock.imageMobile[1]) === null || _selectedBlock$imageM3 === void 0 ? void 0 : _selectedBlock$imageM3.src) && !isSecondImageOpen && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__next-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '19px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: handleNextImage
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "18",
      r: "17",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M13.7908 27.9548L24.3868 18.1175L13.7908 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__sub-container ".concat(isFirstImageOpen ? "factual__first-image-container" : "")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h1", {
      className: "factual__title"
    }, block.title, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("sup", null, block.title_sup)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("p", {
      className: "factual__description",
      dangerouslySetInnerHTML: {
        __html: block.description
      }
    }), block.pyramid && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "pyramid__cards"
    }, block.pyramid.map((card, cardIndex) => {
      var text = card.text;
      if (text) {
        var myStyle = {
          background: "".concat(card.color)
        };
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__pyramid-card-container",
          key: "pyramid-".concat(cardIndex)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          class: "try"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          key: cardIndex,
          style: myStyle,
          className: "factual__card-item factual__pyramid-item",
          onClick: () => handleCardClick(card)
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-content factual__pyramid-content"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h1", {
          className: "factual__code factual__pyramid-code"
        }, card.text)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__pyramid-title-desc"
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__card-title factual__pyramid-title",
          dangerouslySetInnerHTML: {
            __html: "".concat(card.card_title, "<sup>").concat(card.sup, "</sup>")
          }
        }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: "factual__pyramid-title",
          dangerouslySetInnerHTML: {
            __html: "".concat(card.card_desc)
          }
        })));
      }
      return null;
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__right factual__right-".concat(blockCount)
    }, isSecondImageOpen && !isFirstBlock && !src ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "factual__right-image",
      style: {
        position: 'relative'
      }
    }, !isMobile ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.59,
      image: {
        src: selectedBlock === null || selectedBlock === void 0 || (_selectedBlock$imageS3 = selectedBlock.imageSrc[1]) === null || _selectedBlock$imageS3 === void 0 ? void 0 : _selectedBlock$imageS3.src,
        width,
        height
      },
      srcTokens: srcTokens
    }) : src && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: " ".concat(block.hideImage === "true" ? "factual__hide-image" : "", " ")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.9,
      image: {
        src,
        width,
        height
      },
      srcTokens: srcTokens
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "close-icon",
      style: {
        position: 'absolute',
        top: '50%',
        right: '17px',
        cursor: 'pointer',
        zIndex: 15
      },
      onClick: () => setIsSecondImageOpen(false)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
      width: "35",
      height: "36",
      viewBox: "0 0 35 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("circle", {
      cx: "17.5",
      cy: "17.5",
      r: "17",
      transform: "matrix(-1 0 0 1 35 0.5)",
      fill: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color,
      stroke: selectedBlock === null || selectedBlock === void 0 ? void 0 : selectedBlock.color
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
      d: "M21.2092 27.9548L10.6132 18.1175L21.2092 8.28074",
      stroke: "#FEFDF6",
      strokeWidth: "2"
    })))) : src && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: " ".concat(block.hideImage === "true" ? "factual__hide-image" : "", " ")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_2__["default"], {
      aspectratio: 0.9,
      aspect_ratio_mobile: 0.9,
      image: {
        src,
        width,
        height
      },
      srcTokens: srcTokens
    }))));
  })) : '');
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FactualSection);

/***/ }),

/***/ "./js/components/react/slider.js":
/*!***************************************!*\
  !*** ./js/components/react/slider.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ResponsiveImage */ "./js/components/react/ResponsiveImage.js");
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! framer-motion */ "./node_modules/framer-motion/dist/es/render/components/motion/proxy.mjs");



var slider = _ref => {
  var _shopifyData$data;
  var {
    shopifyData
  } = _ref;
  var slides = (_shopifyData$data = shopifyData.data) === null || _shopifyData$data === void 0 ? void 0 : _shopifyData$data.blocks;
  var blockSize = slides.length;
  var [currentSlideIndex, setCurrentSlideIndex] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  var [currentSlide, setCurrentSlide] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(slides[0]);
  var width = 1920;
  var height = 1080;
  console.log("slider---", slides);
  var settings = {
    imageFit: 'cover'
  };
  var renderNavigationBar = () => {
    var bars = [];
    for (var i = 0; i < blockSize; i++) {
      bars.push(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
        className: currentSlideIndex == i ? 'bar active' : 'bar'
      }));
    }
    return bars;
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setCurrentSlide(slides[currentSlideIndex]);
  }, [currentSlideIndex]);
  var slideVariants = {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  };
  if (currentSlide) {
    var _currentSlide$mobile_, _currentSlide$slide_i, _currentSlide$mobile_2, _currentSlide$slide_i2, _currentSlide$bundle_;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
      className: "h1 slideshow__head mb-1 mobile-only"
    }, currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_header), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow bannerSlider"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__.motion.div, {
      className: "slideshow__banner-image",
      key: currentSlideIndex,
      initial: "initial",
      animate: "animate",
      exit: "exit",
      variants: slideVariants,
      transition: {
        duration: 0.9,
        ease: "linear"
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_1__["default"], {
      aspectratio: 1.8,
      aspect_ratio_mobile: 0.9,
      image: {
        src: window.innerWidth <= 768 && currentSlide !== null && currentSlide !== void 0 && currentSlide.mobile_image ? currentSlide === null || currentSlide === void 0 || (_currentSlide$mobile_ = currentSlide.mobile_image[0]) === null || _currentSlide$mobile_ === void 0 ? void 0 : _currentSlide$mobile_.src : currentSlide === null || currentSlide === void 0 || (_currentSlide$slide_i = currentSlide.slide_image[0]) === null || _currentSlide$slide_i === void 0 ? void 0 : _currentSlide$slide_i.src,
        width,
        height,
        alt: window.innerWidth <= 768 && currentSlide !== null && currentSlide !== void 0 && currentSlide.mobile_image ? currentSlide === null || currentSlide === void 0 || (_currentSlide$mobile_2 = currentSlide.mobile_image[0]) === null || _currentSlide$mobile_2 === void 0 ? void 0 : _currentSlide$mobile_2.alt : currentSlide === null || currentSlide === void 0 || (_currentSlide$slide_i2 = currentSlide.slide_image[0]) === null || _currentSlide$slide_i2 === void 0 ? void 0 : _currentSlide$slide_i2.alt
      },
      settings: settings
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow__card-content slideshow__slideBody d-flex d-flex-dir-c justify-content-space-btw desktop-only",
      role: "region",
      "aria-label": "Slide Text"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
      className: "h1 slideshow__head mb-1"
    }, currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_header), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
      className: "mb-2"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "slide_index"
    }, currentSlideIndex + 1), currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.subheading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "slideshow__subtext"
    }, currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_sub_text), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow__navigation"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
      style: {
        opacity: currentSlideIndex === 0 ? 0.5 : 1,
        pointerEvents: currentSlideIndex === 0 ? 'none' : 'auto'
      },
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: () => currentSlideIndex > 0 && setCurrentSlideIndex(currentSlideIndex - 1)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
      r: "17.5",
      transform: "matrix(-1 0 0 1 18 18)",
      stroke: "rgba(var(--color-controls)/1)"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
      d: "M14.5234 13.4961L9.81889 18.2006L14.5234 22.9052",
      stroke: "rgba(var(--color-controls)/1)"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
      d: "M10.0234 18.2031L26.1825 18.2031",
      stroke: "rgba(var(--color-controls)/1)"
    })), renderNavigationBar(), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
      style: {
        opacity: currentSlideIndex == blockSize - 1 ? 0.5 : 1,
        pointerEvents: currentSlideIndex == blockSize ? 'none' : 'auto'
      },
      width: "36",
      height: "36",
      viewBox: "0 0 36 36",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      onClick: () => currentSlideIndex < blockSize - 1 && setCurrentSlideIndex(currentSlideIndex + 1)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("circle", {
      cx: "18",
      cy: "18",
      r: "17.5",
      stroke: "rgba(var(--color-controls)/1)"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
      d: "M21.4766 13.4961L26.1811 18.2006L21.4766 22.9052",
      stroke: "rgba(var(--color-controls)/1)"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
      d: "M25.9766 18.2031L9.81747 18.2031",
      stroke: "rgba(var(--color-controls)/1)"
    }))))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "btn--wrap"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
      className: "btn btn--fill slideshow__shop-btn",
      href: currentSlide.slide_product_url
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow__shop-btn-text"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Shop the ", currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_product_title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, currentSlide === null || currentSlide === void 0 || (_currentSlide$bundle_ = currentSlide.bundle_products) === null || _currentSlide$bundle_ === void 0 ? void 0 : _currentSlide$bundle_.join(', ')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_product_price)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow__shop-btn--hover-text"
    }, "SHOP NOW")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "slideshow__slideBody slideshow__slideBody--mobile mobile-only"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h1", {
      className: "mb-2"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "slide_index"
    }, currentSlideIndex + 1), currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.subheading), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "navigations mobile-only"
    }, currentSlideIndex != 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
      className: "slide-prev--mobile",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      onClick: () => currentSlideIndex > 0 && setCurrentSlideIndex(currentSlideIndex - 1)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    })), currentSlideIndex < blockSize - 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      onClick: () => currentSlideIndex < blockSize - 1 && setCurrentSlideIndex(currentSlideIndex + 1)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 10.5703 22.5703)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
      y1: "-1",
      x2: "16.9706",
      y2: "-1",
      transform: "matrix(0.707107 0.707107 0.707107 -0.707107 12.002 0)",
      stroke: "#282FEE",
      "stroke-width": "2"
    })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
      className: "slideshow__subtext"
    }, currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.slide_sub_text)));
  }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (slider);

/***/ }),

/***/ "./js/components/react/subscription-options.js":
/*!*****************************************************!*\
  !*** ./js/components/react/subscription-options.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _frequency_options__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./frequency-options */ "./js/components/react/frequency-options.js");

// import "StyleComponents/subscription-sec.scss";

var SubscriptionOptions = _ref => {
  var {
    updateSellingPlan,
    sellingplan,
    selectedVariant,
    selectedSellingPlan,
    onUpdate,
    purchaseType,
    subscription_plan
  } = _ref;
  var {
    price,
    priceWithoutCurrency
  } = selectedVariant;
  var {
    priceAdjustments,
    discount
  } = selectedSellingPlan;
  var [subscriptionBenefits, setSubscriptionBenefits] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
  var discountNum = parseFloat(discount);
  var numPriceWithoutCurrency = parseFloat(price.replace('$', '').replace(',', '')) || 0;
  var numPrice = parseFloat(price.replace('$', '')) || 0;
  var calculateDiscountedPrice = function calculateDiscountedPrice() {
    var offerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    if (offerType == 'percentage') {
      var discountedPrice = numPriceWithoutCurrency * (1 - discountNum / 100);
      return discountedPrice.toFixed(2);
    } else if (offerType == 'fixed_amount') {
      var fixedAmt = numPriceWithoutCurrency - flatRate;
      return fixedAmt.toFixed(2);
    } else if (offerType == 'price') {
      return flatRate.toFixed(2);
    }
  };
  var calculateOffer = offerType => {
    if (offerType === "percentage") {
      return "".concat(discountNum, "%");
    } else if (offerType === "fixed_amount") {
      var newFixedAmountValue = discountNum / 100;
      return "$".concat(newFixedAmountValue.toFixed(2));
    } else if (offerType === "price") {
      var newValue = numPriceWithoutCurrency - discountNum / 100;
      return "$".concat(newValue.toFixed(2));
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    subscription_plan.map(plan => {
      if (selectedSellingPlan.frequency === plan.frequency) {
        setSubscriptionBenefits(plan.benefits);
      }
    });
  }, [selectedSellingPlan]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "subscriptionOpt-container__subscription-wrapper variant-container__var-wrapper ".concat(purchaseType != 'onetime' ? 'active' : ''),
    onClick: () => {
      onUpdate("subscription");
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "subscriptionOpt-container__subscription-label"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "8",
    viewBox: "0 0 10 8",
    fill: "none",
    className: "".concat(purchaseType != 'onetime' ? 'active' : '')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.61589",
    y1: "6.67991",
    x2: "9.61589",
    y2: "0.679908",
    stroke: "white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "4.64645",
    y1: "7.35355",
    x2: "1.11091",
    y2: "3.81802",
    stroke: "white"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Subscribe ", discount > 0 && "& Save")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "subscriptionOpt-container__subscription-Price"
  }, calculateDiscountedPrice(priceAdjustments) < numPrice && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "sub-compare-at-price"
  }, "$", numPrice), " $", calculateDiscountedPrice(priceAdjustments)), purchaseType != "onetime" && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_frequency_options__WEBPACK_IMPORTED_MODULE_1__["default"], {
    sellingplan: sellingplan,
    selectedSellingPlan: selectedSellingPlan,
    onUpdate: updateSellingPlan,
    subscriptionPlan: subscription_plan
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "subscription_benefits"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", null, "Subscription Benefits"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", null, subscriptionBenefits === null || subscriptionBenefits === void 0 ? void 0 : subscriptionBenefits.map((benefit, index) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
    key: index
  }, benefit)))))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SubscriptionOptions);

/***/ }),

/***/ "./js/components/react/tooltip.js":
/*!****************************************!*\
  !*** ./js/components/react/tooltip.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

var Tooltip = _ref => {
  var {
    setShowTooltip,
    subscriptionPlan
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip__header"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "tooltip__title"
  }, "Frequency Recommendation"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tooltip__closeButton",
    onClick: () => setShowTooltip(false)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "0.353553",
    y1: "0.388634",
    x2: "14.4957",
    y2: "14.5308",
    stroke: "#282FEE"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("line", {
    x1: "14.4942",
    y1: "0.353553",
    x2: "0.352042",
    y2: "14.4957",
    stroke: "#282FEE"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "tooltip__subtitle"
  }, "We recommend the following replenishment cycle:"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip__content--left"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "usage_title"
  }, "Usage:"), subscriptionPlan.map(plan => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "usage_content"
  }, plan.usage))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tooltip__content--right"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "frequency_title"
  }, "Frequency:"), subscriptionPlan.map(plan => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("p", {
    className: "frequency_content"
  }, plan.frequency)))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Tooltip);

/***/ }),

/***/ "./js/components/react/variant-selector.js":
/*!*************************************************!*\
  !*** ./js/components/react/variant-selector.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _onetime_options__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./onetime-options */ "./js/components/react/onetime-options.js");
/* harmony import */ var _subscription_options__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./subscription-options */ "./js/components/react/subscription-options.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



// import 'StyleComponents/variant-options.scss';
// import 'StyleComponents/subscription-sec.scss';

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    shopifyData
  } = _ref;
  var [purchaseType, setPurchaseType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('onetime');
  var {
    variants,
    sellingplan,
    options,
    selected,
    subscription_plan
  } = shopifyData.data;
  var [selectedVariant, setSelectedVariant] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(variants.find(variant => variant.id == selected));
  var [selectedSellingPlan, setselectedSellingPlan] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(sellingplan[0] || {});
  var updateSelectedVariant = variantObj => {
    var {
      id
    } = variantObj;
    var selectedVariant = variants.find(variant => variant.id == id);
    setSelectedVariant(selectedVariant);
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    var {
      priceWithoutCurrency
    } = selectedVariant;
    var price = priceWithoutCurrency === null || priceWithoutCurrency === void 0 ? void 0 : priceWithoutCurrency.trim();
    if (purchaseType != "onetime") {
      if (selectedSellingPlan) {
        var {
          priceAdjustments,
          discount
        } = selectedSellingPlan;
        var discountNum = parseInt(discount);
        var numPriceWithoutCurrency = parseFloat(priceWithoutCurrency) || 0;
        var calculateDiscountedPrice = function calculateDiscountedPrice() {
          var offerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          if (offerType == 'percentage') {
            var discountedPrice = numPriceWithoutCurrency * (1 - discountNum / 100);
            return discountedPrice.toFixed(2);
          } else if (offerType == 'fixed_amount') {
            var fixedAmt = numPriceWithoutCurrency - flatRate;
            return fixedAmt.toFixed(2);
          } else if (offerType == 'price') {
            return flatRate.toFixed(2);
          }
        };
        price = calculateDiscountedPrice(priceAdjustments);
      }
    }
    document.querySelectorAll('[data-segmented-price]').forEach(priceInput => priceInput.value = price);
  }, [selectedVariant, purchaseType]);
  window.updateSelectedVariant = updateSelectedVariant;
  var handleSwitch = purchaseType => {
    setPurchaseType(purchaseType);
  };
  var handleVariantChange = obj => {
    setSelectedVariant(_objectSpread({}, obj));
  };
  var updateSellingPlan = sellingPlanObj => {
    setselectedSellingPlan(_objectSpread({}, sellingPlanObj));
  };
  var updateInputValues = (inputs, value) => {
    inputs.forEach(input => {
      if (input.closest('[data-product-form]')) {
        input.value = value;
      }
    });
  };
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    //since product-form custom element code is compiled and is not set to initialise on connected callback
    //we are simply updating the input values in the existing product form
    var variantInputs = document.querySelectorAll('input[name="id"]');
    var sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    var sellingFrequencyInput = document.querySelectorAll('[data-selling-frequency]');
    updateInputValues(variantInputs, selectedVariant.id);
    if (purchaseType == "subscription") {
      updateInputValues(sellingPlanInputs, selectedSellingPlan.id);
      updateInputValues(sellingFrequencyInput, selectedSellingPlan.frequency);
    } else {
      updateInputValues(sellingPlanInputs, '');
      updateInputValues(sellingFrequencyInput, '');
    }
    var priceContainer = document.querySelector('.product-price__current-price');
    if (priceContainer) {
      priceContainer.innerHTML = selectedVariant.price;
    }
  }, [selectedVariant, purchaseType, selectedSellingPlan]);
  var productOriginalPrice = parseFloat(selectedVariant.price.replace('$', '').replace(',', ''));
  var numProductCompareAtPrice = parseFloat(selectedVariant.compareAtPrice.replace('$', '').replace(',', ''));
  var productComparePrice;
  if (numProductCompareAtPrice > productOriginalPrice) {
    productComparePrice = selectedVariant.compareAtPrice;
  }
  if (!productComparePrice) {
    productComparePrice = selectedVariant.OriginalCompareAtPrice;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, sellingplan.length > 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "variant-container__purchaseType-wrapper"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_onetime_options__WEBPACK_IMPORTED_MODULE_2__["default"], {
    selectedVariant: selectedVariant,
    purchaseType: purchaseType,
    onUpdate: handleSwitch
  }), Object.keys(selectedSellingPlan).length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_subscription_options__WEBPACK_IMPORTED_MODULE_3__["default"], {
    updateSellingPlan: updateSellingPlan,
    sellingplan: sellingplan,
    selectedVariant: selectedVariant,
    purchaseType: purchaseType,
    selectedSellingPlan: selectedSellingPlan,
    onUpdate: handleSwitch,
    subscription_plan: subscription_plan
  }))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("s", null, " ", productComparePrice), " ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: productComparePrice ? "product-sale-color" : ""
  }, " ", selectedVariant.price, " "), " ", productComparePrice && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "product-sale-color"
  })));
});

/***/ }),

/***/ "./js/components/svelte-wrapper.js":
/*!*****************************************!*\
  !*** ./js/components/svelte-wrapper.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  console.log("---------svelte-------");
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    var props = {};
    if (appTarget && !initialized) {
      var _props;
      if (propsEl) {
        var _appTarget$querySelec;
        props = json_6__WEBPACK_IMPORTED_MODULE_0___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
      }
      //inject component into container
      var instance = new Component({
        target: appTarget,
        props: {
          shopifyData: (_props = props) === null || _props === void 0 ? void 0 : _props.data //pass the prop on data prop as default
        }
      });
      appTarget.dataset.initialized = true;
      return instance;
    }
  });
});

/***/ }),

/***/ "./js/components/svelte/hello.svelte":
/*!*******************************************!*\
  !*** ./js/components/svelte/hello.svelte ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var svelte_internal__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! svelte/internal */ "./node_modules/svelte/src/runtime/internal/index.js");
/* harmony import */ var svelte_internal_disclose_version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! svelte/internal/disclose-version */ "./node_modules/svelte/src/runtime/internal/disclose-version/index.js");
/* js/components/svelte/hello.svelte generated by Svelte v4.2.20 */




function create_fragment(ctx) {
	let div;

	return {
		c() {
			div = (0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.element)("div");
			div.textContent = "hiiii";
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.attr)(div, "class", "tab-section");
		},
		m(target, anchor) {
			(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.insert)(target, div, anchor);
		},
		p: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		i: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		o: svelte_internal__WEBPACK_IMPORTED_MODULE_0__.noop,
		d(detaching) {
			if (detaching) {
				(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.detach)(div);
			}
		}
	};
}

function instance($$self) {
	console.log("----------");
	return [];
}

class Hello extends svelte_internal__WEBPACK_IMPORTED_MODULE_0__.SvelteComponent {
	constructor(options) {
		super();
		(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.init)(this, options, instance, create_fragment, svelte_internal__WEBPACK_IMPORTED_MODULE_0__.safe_not_equal, {});
	}
}

(0,svelte_internal__WEBPACK_IMPORTED_MODULE_0__.create_custom_element)(Hello, {}, [], [], true);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Hello);

/***/ })

}]);